    
    <div class="pdftopbar">
    <button (click)="createPdf()" class="pdfmake">pdfCreate</button>
    <div #headerData>
        <div class="header">
           <div class="mr-auto">
           
            <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"> {{pdfData?.stateCode}}-{{pdfData?.agreementNumber}}-{{pdfData?.agreementStartDate | date: 'ddMMYYYY'}}</div>
          </div> 
        </div>
        <svg>
            <text transform="translate(24, 300) rotate(-90)" font-size="12px" position='absolute'
                left='0px' width='0' white-space='nowrap'>
                {{pdfData?.createdAt | date: 'ddMMyyyy'}}
            </text>
        </svg>

        <svg>
            <text transform="translate(24, 600) rotate(-90)" font-size="12px" position='absolute'
                left='0px' width='0' white-space='nowrap'>
               {{pdfData?.agreementNumber}}-V0{{pdfData?.agreementVersion}}-{{pdfData?.agreementPurchaseDate | date: 'ddMMYYYY'}}
            </text>
        </svg>

       
    </div>
    </div>

    <div class="container" #htmlData style="max-width: 1360px;">
        

        <div class="bodyprt">

            <div class="strongfont marbottom">
                WELCOME TO ELITE HOME WARRANTY
            </div>
            <div class="innerbody">
                
                <p class="startfontpara"><strong>Dear <span
                            style="color: #df3762;">{{pdfData?.firstName}} {{pdfData?.lastName}},</span></strong></p>

                <p class="smallfontpara">
                    Thank you for joining our family at Elite Home Warranty . We consider it a privilege to
                    have you as a customer.
                </p>
                <p class="smallfontpara">
                    Elite Home Warranty care for your home as it is ours. You can now focus on enjoying
                    your life as we provide you with a simpler, stress-free home ownership experience.
                </p>
                <p class="smallfontpara">
                    We strive to make your life easier and we are here to assist 24 hours a day 7-days a
                    week.
                </p>
                <p class="smallfontpara">
                    We are happy you have joined us. As a customer, we will treat your home like it is our
                    own and provide you with the highest level of service for all your home warranty needs,
                    our customer service is second to none.
                </p>
                <p class="smallfontpara">
                    We are licensed and sanctioned where required to offer home warranties. We offer
                    generous coverage and higher caps. You have the option to fully customize your
                    coverage plan according to your needs.
                </p>
                <p class="smallfontpara">
                    At Elite Home Warranty®, you have the ability to perform almost every transaction in a
                    few clicks from any device instantly by accessing your online account.
                </p>

                <ul class="smallfontpara ul">
                    <li>
                        - Access Your Agreement
                    </li>
                    <li>
                        - Request Service 24/7
                    </li>
                    <li>
                        - Edit Your Coverage
                    </li>
                    <li>
                        - Renew Your Agreement
                    </li>
                    <li>
                        - Access Claims
                    </li>
                </ul>
                <p class="smallfontpara">
                    We are always here for you, let us know if have any questions about your home
                    warranty service agreement or if you would like to add additional coverage to your plan.
                </p>
                <p class="smallfontpara">
                    Visit us online at or call us at (888) 354-8398 as we are here for WWW.ELITEHW.COM
                    you 24 hours a day 7-days a week.
                </p>
                <p class="smallfontpara">
                    We look forward to helping you when you need us the most.
                </p>
                
                <p class="smallfontpara">
                    Stay Safe,
                </p>
                <p class="smallfontpara">
                    The Elite Home Warranty Family
                </p>
                <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[20,150,20,150], &quot;thickness&quot;:2}"></div>
                <h1 class="strongfont">REFERRAL PROGRAM</h1>
                <h2 class="startfontpara textcenter">
                    Join our referral program to
                    earn <b style="color: #fa634e;">FREE months of coverage</b>.
                  </h2>

                  <h2 class="startfontpara textcenter">
                    <strong>
                      INTRODUCE FAMILY MEMBERS AND FRIENDS
                      TO ELITE HOME WARRANTY.
                    </strong>
                  </h2>

                  <p class="smallfontpara textcenter">
                    Simply refer your family and friends and have them mention the name
                    and phone number associated with your account at the time of signing up.
                    A free month of coverage will then be added to both accounts.
                  </p>
                  <div data-pdfmake="{&quot;margin&quot;:[50,50,50,50], &quot;thickness&quot;:2}"></div>
                  <h2 class="startfontpara textcenter">
                    <strong>
                      EARN <b style="color: #fa634e;">FREE MONTH OF COVERAGE</b>
                      FOR EACH FAMILY MEMBER AND FRIENDS
                      THAT OPT IN FOR OUR COVERAGE.
                    </strong>
                  </h2>
                  <h2 class="startfontpara textcenter" style="color: #fa634e;">
                    <strong>
                      WE LOOK FORWARD TO MAKING YOU AN
                      ELITE HOME WARRANTY MEMBER FOR LIFE.
                    </strong>
                  </h2>

                  <div class="textcenter">
                    <img src="eliteLogo" alt="#" />
                  </div>


                  <div data-pdfmake="{&quot;margin&quot;:[200,200,200,200], &quot;thickness&quot;:2}"></div>

                  <div class="textright">
                    <img src="eliteLogo" alt="#" width="200px"/>
                  </div>

                 
                 
                    <table width="100%" data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}" class="table">
                        <tr>
                            <td style="width: 12%;">
                              <img src="qrcode" alt="#" width="50px"/>
                             </td>
                            <td style="width: 88%;">
                              <span>
                                <p class="margin0 addfontpara">{{pdfData?.stateCode}}-{{pdfData?.agreementNumber}}-{{pdfData?.agreementStartDate | date: 'ddMMYYYY'}}</p>
                                <p class="margin0 addfontpara"><b>{{pdfData?.agreementNumber}}-V0{{pdfData?.agreementVersion}}-{{pdfData?.agreementPurchaseDate | date: 'ddMMYYYY'}}</b></p>
                              </span>
                            </td>
                           
                          </tr>
                          <tr>
                            <td colspan="2">
                              <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}" class="table">
                                <tr>
                                  <td>
                                    <h5>
                                      {{pdfData?.firstName}} {{pdfData?.lastName}}
                                    </h5>
                                    <p class="addfontpara">
                                      {{pdfData?.propertyAddress?.streetAddress}}
                                    </p>
                                    <p class="addfontpara">
                                      {{pdfData?.propertyAddress?.city}}, {{pdfData?.propertyAddress?.state}}, {{pdfData?.propertyAddress?.zip}}
                                    </p>
                                  </td>
                                  <td>
                                    <h5>
                                      Account Executive
                                    </h5>
                                    <p class="addfontpara">
                                      {{agentDetails?.userName}}
                                    </p>
                                    <p class="addfontpara">
                                      (XXX) XXX-XXXX
                                    </p>
                                    <p class="addfontpara">
                                      {{agentDetails?.email}}
                                    </p>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="2">
                                    <div data-pdfmake="{&quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>
                                  </td>
                                </tr>

                                <tr>
                                  <td style="width: 70%;">
                                    <h2 class="startfontpara">
                                      WELCOME
                                    </h2>
                                    <p class="smallfontpara">
                                      Dear {{pdfData?.firstName}} {{pdfData?.lastName}},
                                    </p>
                                    <p class="smallfontpara">
                                      Please take a moment to review the materials in this package.
                                      You'll find a summary of your selected coverage, as well as the
                                      full details of your home warranty service agreement.
                                    </p>
                                    <p class="smallfontpara">
                                      "Elite Home Warranty® care for your home as it is ours. We
                                      are here to prevent small problems from becoming costly
                                      headaches. Our plans cover nearly every mechanical
                                      component in the home with minimal exclusions.<br/>
      
                                      Elite Home Warranty® was founded on the belief that
                                      homeowners deserve better home protection. Our goal is to
                                      provide the best home warranty coverage and services.<br/>
      
      
                                      You can file a claim online 24 hours a day, 7 days a week or with
                                      our friendly concierge team. We process claims quickly and
                                      ensure you are updated every step of the way. Our home
                                      warranty plans are customized for you with higher coverage
                                      limit than traditional home warranties for appliances and
                                      systems.<br/> 
      
                                      We provide the exceptional service we would like to experience
                                      ourselves. We look forward to making you an Elite Home
                                      Warranty® member for life."
                                    </p>
                                  </td>
      
                                  <td style="width: 30%;">
                                    <div data-pdfmake="{&quot;margin&quot;:[20,30,20,30], &quot;thickness&quot;:2}">
                                      <p class="midfontpara">
                                        Request SERVICE
                                        Online 24 hours a day -
                                        7 days a week.
                                      </p>
                                      <p class="midfontpara">
                                        Visit your account at
                                        WWW.ELITEHW .COM
                                        or call (888) 222-1202
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2" class="textcenter">
                                    <h2 style="color: #fa6752;">
                                      Customer Relations
                                    </h2>
                                    <h3>
                                      Elite Home Warranty
                                    </h3>
                                  </td>
                                </tr>
  
                              </table>
                            </td>
                           
                          </tr>

                          
                          

                         
                      </table>
                      

                      
                      <div class="strongfont marbottom">
                        QUESTIONS AND ANSWERS
                      </div>
                      <ul class="listing" data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              Do you conduct home inspections?
                            </h3>
                            <p class="smallfontpara">
                              We do not require home inspection. However, we do require a 30 days waiting period
                              before your coverage begin. You have the ability to remove your waiting period by
                              providing a proof of inspection. You can easily upload proof of inspection documents
                              by accessing your account online.
                            </p>
                          </li>

                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              What happens if I change my mind?
                            </h3>
                            <p class="smallfontpara">
                              We strongly believe that you will be very satisfied with our service and we do allow
                              cancellations if you feel otherwise. You can cancel your service agreement within 30
                              days after the purchase date to get a full refund without paying any cancellation fees.
                              After that, you can cancel at any time for a prorated refund, and you may have to pay a
                              small cancellation fee. Please refer to your service agreement for more details.
                            </p>
                          </li>
                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              Are there any age restrictions on covered items?
                            </h3>
                            <p class="smallfontpara">
                              We cover all items regardless of the age. Items older than 10 years are limited to
                                repair only. Covered items that are not repairable are limited to reduced cash payout.
                                We require that all covered items be fully operating at the time of purchasing your
                                agreement.
                            </p>
                          </li>
                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              Are there any brand restrictions on covered items?
                            </h3>
                            <p class="smallfontpara">
                              We cover all brands, no exclusions. However, we do charge a higher copayment fee on
                              any professional grade appliances.
                            </p>
                          </li>

                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              Do you have any restrictions on claims?
                            </h3>
                            <p class="smallfontpara">
                              We do cover almost all mechanical parts with minimal exclusions. Please take a
                              moment to review your service agreement carefully for limitations and exclusions.
                            </p>
                          </li>

                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                            <h3>
                              Do you have a limit on claims?
                            </h3>
                            <p class="smallfontpara">
                              We do not have any limits on the number of claims that you can file annually.
    However, we do have limits on each covered item, and a standard aggregated payout
    limit per agreement term of up to $15,000.
                            </p>
                          </li>

                          <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h3>
                              Can I file a claim online?
                              </h3>
                              <p class="smallfontpara">
                                You can easily file and manage your claims online 24 hours a day 7-days a week. This is
      our preferred way. You can also file claims with a live representative by calling our
      friendly claims department at (888) 222-1202.
                              </p>
                          </li>
                        </ul>
                      
                        <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                      <div class="strongfont marbottom">
                        HOME WARRANTY AGREEMENT
                      </div>
                      <h2 class="startfontpara textcenter" style="color: rgb(82, 81, 81);">
                        ACCOUNT SUMMARY
                      </h2>
                      <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5]}"></div>
                      <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td style="width:60%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr data-pdfmake="{&quot;widths&quot;:[50]}">
                                <td>
                                  <h5 class="smallfontpara">AGREEMENT HOLDER SINCE:</h5>
                                  <p class="smallfontpara">{{pdfData?.agreementStartDate | date: 'dd/MM/yyy'}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">AGREEMENT NUMBER:</h5>
                                  <p class="smallfontpara">{{pdfData?.agreementNumber}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">COVERAGE TERM:</h5>
                                  <p class="smallfontpara">{{pdfData?.coverageTerm}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">WAITING PERIOD:</h5>
                                  <p class="smallfontpara">{{pdfData?.waitingPeriod}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">AGREEMENT EFFECTIVE DATE:</h5>
                                  <p class="smallfontpara">{{pdfData?.agreementStartDate | date: 'dd/MM/yyy'}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PROPERTY COVERED:</h5>
                                  <p class="smallfontpara">{{pdfData?.propertyAddress?.streetAddress}}
                                    {{pdfData?.propertyAddress?.city}}, {{pdfData?.propertyAddress?.state}}, {{pdfData?.propertyAddress?.zip}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PROPERTY SIZE:</h5>
                                  <p class="smallfontpara">{{pdfData?.planPropertySize?.title}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PROPERTY TYPE:</h5>
                                  <p class="smallfontpara">{{pdfData?.planPropertyTypeName}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>

                          <td style="width:40%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">NEW/RENEWAL:</h5>
                                  <p class="smallfontpara">{{pdfData?.agreementEndDate | date: 'dd/MM/yyy'}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PURCHASE DATE:</h5>
                                  <p class="smallfontpara">{{pdfData?.agreementPurchaseDate | date: 'MMM dd, yyyy'}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">AGREEMENT PRICE:</h5>
                                  <p class="smallfontpara">${{pdfData?.agreementPrice}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">SURCHARGE:</h5>
                                  <p class="smallfontpara">${{pdfData?.surchargeAmount}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">TOTAL PRICE:</h5>
                                  <p class="smallfontpara">${{pdfData?.totalAmount}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">MONTHLY PAYMENT:</h5>
                                  <p class="smallfontpara">${{pdfData?.downPaymentAmount}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PAYMENT TYPE:</h5>
                                  <p class="smallfontpara">{{pdfData?.paymentType}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">INITIAL PAYMENT:</h5>
                                  <p class="smallfontpara">${{pdfData?.downPaymentAmount}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                         
                          <td colspan="2" class="agreementprt">
                           <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;50px&quot;}">
                              <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                                AGREEMENT TOTAL PRICE INCLUDES APPLICABLE SALES TAX
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </table>
                      <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                      <h2 class="startfontpara textcenter" style="color: rgb(82, 81, 81);">
                        PAYMENT DETAILS
                      </h2>

                      <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td style="width:60%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">TOTAL PAID:</h5>
                                  <p class="smallfontpara">${{pdfData?.totalAmount}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">TYPE:</h5>
                                  <p class="smallfontpara">{{pdfData?.paymentMethod.replace('-', ' ') | titlecase}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td style="width:40%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">REMAINING BALANCE:</h5>
                                  <p class="smallfontpara">${{pdfData?.remainingAmount}}</p>
                                </td>
                              </tr>
                              <tr *ngIf="pdfData?.paymentInformation">
                                <td>
                                  <h5 class="smallfontpara">PAYMENT INFO:</h5>
                                  <p class="smallfontpara">{{pdfData?.paymentInformation}}</p>
                                </td>
                              </tr>
                              <tr *ngIf="pdfData?.escrowDueDate">
                                <td>
                                  <h5 class="smallfontpara">ESCROW DUE DATE:</h5>
                                  <p class="smallfontpara">{{pdfData?.escrowDueDate | date: 'MMM dd, yyyy'}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>

                      <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                      <h2 *ngIf="pdfData?.coverageTerm !== 'Monthly' && pdfData?.paymentType !== 'Full Payment'" class="startfontpara textcenter" style="color: rgb(82, 81, 81);">
                        UPCOMING PAYMENTS
                      </h2>
                     
                      <table *ngIf="pdfData?.coverageTerm !== 'Monthly'  && pdfData?.paymentType !== 'Full Payment'"  data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td style="width:60%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">No additional payments are due.</h5>
                                  <p class="smallfontpara">&nbsp;</p>
                                </td>
                              </tr>
                             
                            </table>
                          </td>
                          <td style="width:40%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr *ngFor="let upcomming of pdfData?.upcomingPayments">
                                <td>
                                  <h5 class="smallfontpara">{{upcomming?.dueDate | date: 'MMM dd, yyyy'}}</h5>
                                  <p class="smallfontpara">${{upcomming?.amountPaid}}</p>
                                </td>
                              </tr>
                            
                            </table>
                          </td>
                        </tr>
                      </table>
                      <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                      <h2 class="startfontpara textcenter" style="color: rgb(82, 81, 81);">
                        PLEASE VERIFY YOUR ACCOUNT INFORMATION
                      </h2>

                      <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td style="width:60%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">AGREEMENT HOLDER:</h5>
                                  <p class="smallfontpara">{{pdfData?.firstName}} {{pdfData?.lastName}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">EMAIL ADDRESS:</h5>
                                  <p class="smallfontpara">{{pdfData?.emailAddress}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td style="width:40%">
                            <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">MAILING ADDRESS:</h5>
                                  <p class="smallfontpara">{{pdfData?.mailingAddress?.streetAddress}}
                                    {{pdfData?.mailingAddress?.city}}, {{pdfData?.mailingAddress?.state}}, {{pdfData?.mailingAddress?.zip}}</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h5 class="smallfontpara">PHONE NUMBER:</h5>
                                  <p class="smallfontpara">({{pdfData?.phoneNumber.slice(0, 3)}}) {{pdfData?.phoneNumber.slice(3, 6)}}-{{pdfData?.phoneNumber.slice(6, 10)}}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>

                      <div data-pdfmake="{&quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>

                      <div class="strongfont marbottom">
                        OVERVIEW OF YOUR SELECTED COVERAGE
                      </div>
                      <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td style="width:50%">
                            <h5>TYPE OF PLAN: <b style="color: #fa634e;">{{pdfData?.mainPlan?.title}}</b></h5>
                          </td>
                          <td style="width:50%">
                            <h5 class="textright">COPAYMENT FEE: <b style="color: #fa634e;">$XX</b></h5>
                          </td>
                        </tr>
                        <tr>
                          <td style="width:100%" colspan="2">
                            <h5 class="textcenter">SPECIAL COPAYMENT FEE: <b style="color: #fa634e;">$XXX</b></h5>
                          </td>
                        </tr>
                        
                        <tr>
                          <td colspan="2" style="color: #fa634e; font-weight: bold;">
                            <h4><b class="textcenter">COVERED APPLIANCES</b></h4>
                          </td>
                        </tr>
                        
                        <tr>
                          <td colspan="2" class="textcenter">
                            <p>
                              <strong>MAXIMUM CATEGORY COVERAGE</strong> - Under this section, the liability of EHW is limited to paying in the aggregate up to $7,000 per Term for all Breakdowns which could be covered under this Section, unless additional coverage is purchased andnoted on the Account Summary.
                            </p>
                            <p>
                              <strong>MAXIMUM COVERAGE PER COVERED APPLIANCE</strong> - The Maximum Coverage noted below for each type of appliance applies to a single unit of the covered appliance in issue. If the Account Summary indicates that You purchased coverage for two (2) or more units of the covered appliance in issue, then the MAXIMUM COVERAGE indicated below applies to each unit of the total number of items indicated on the Account Summary, which amount may not exceed the Maximum Category Coverage.
                            </p>
                          </td>
                        </tr>
                      </table>

                     <div>
                      <ul>
                        <li *ngFor="let coverItem of pdfData?.coverAppliances" data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                          <h5>{{coverItem?.title}} [1]</h5>
                              <p>
                                MAXIMUM COVERAGE: {{coverItem?.maximumCoverage}}.
                              </p>
                        </li>

                       
                      </ul>
                     </div>

                     <div class="textcenter">
                        <p>
                          * The number besides each covered appliance indicates the number of units that are covered per covered appliance.
                        </p>
                     </div>
                     <div data-pdfmake="{&quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>
                     <div class="strongfont marbottom">
                      OVERVIEW OF YOUR SELECTED COVERAGE
                    </div>
                    <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                      <tr>
                        <td colspan="2" style="color: #fa634e; font-weight: bold;">
                          <h4><b class="textcenter">COVERED SYSTEMS</b></h4>
                        </td>
                      </tr>
                      
                      <tr>
                        <td colspan="2" class="textcenter">
                          <p>
                            <strong>MAXIMUM CATEGORY COVERAGE</strong> - Under this Section, the liability of EHW is limited to paying in the aggregate up to $8,000 per Term for all Breakdowns which could be covered under this Section, unless additional coverage is purchased on the Account Summary.
                          </p>
                          <p>
                            <strong>MAXIMUM COVERAGE PER COVERED APPLIANCE</strong> - The Maximum Coverage noted below for each type of system applies to a single unit of the covered system in issue. If the Account Summary indicates that You purchased coverage for two (2) or more units of the covered system in issue, then the MAXIMUM COVERAGE indicated below applies to each unit of that type of system indicated on the Account Summary, which amount may not exceed the Maximum Category Coverage.
                          </p>
                        </td>
                      </tr>
                    </table>


                    <div>
                      <ul>
                        <li *ngFor="let item of pdfData?.coverSystems" data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                          <h5>{{item?.title}} [1]</h5>
                              <p>
                                MAXIMUM COVERAGE: {{item?.maximumCoverage}}.
                              </p>
                        </li>
    
                      </ul>
                     </div>
                     
                     <div class="textcenter">
                      <p>
                        * The number besides each covered system indicates the number of units that are covered per covered appliance.
                      </p>
                    </div>
                    <div data-pdfmake="{&quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>
                    <div class="strongfont marbottom">
                      OVERVIEW OF YOUR SELECTED COVERAGE
                    </div>

                    <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                      <tr>
                        <td colspan="2" style="color: #fa634e; font-weight: bold;">
                          <h4><b class="textcenter">COVERED OPTIONAL ITEMS</b></h4>
                        </td>
                      </tr>
                      
                      <tr>
                        <td colspan="2" class="textcenter">
                          <p>
                            <strong>MAXIMUM CATEGORY COVERAGE</strong> - Under this section, the liability of EHW is limited to paying in the aggregate up to $5,000 per Term for all Breakdowns which could be covered under this Section, unless additional coverage is purchased and noted on the Account Summary.
                          </p>
                          <p>
                            <strong>MAXIMUM COVERAGE PER COVERED ITEM OR SYSTEM</strong> - The Maximum Coverage noted below for each type of item or system applies to a single unit of the covered item or system in issue. If the Account Summary indicates that You purchased coverage for two (2) or more units of the covered item or system in issue, then the MAXIMUM COVERAGE indicated below applies to each unit of that type of item or system indicated on the Account Summary, which amount may not exceed the Maximum Category Coverage.
                          </p>
                        </td>
                      </tr>
                    </table>

                    <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                      <tr>
                        <td style="width:50%;">
                          <div>
                            <ul>
                              <li *ngFor="let item of pdfData?.optionalCoverSystems" data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                                <h5>{{item?.title}} [1]</h5>
                                    <p>
                                      MAXIMUM COVERAGE: {{item?.maximumCoverage}}
                                    </p>
                              </li>
                             
                            </ul>
                           </div>
                        </td>

                        <td style="width:50%;">
                          <div>
                            <ul>
                              <li *ngFor="let item of pdfData?.optionalCoverAppliances" data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                                <h5>{{item?.title}} [1]</h5>
                                    <p>
                                      MAXIMUM COVERAGE: {{item?.maximumCoverage}}
                                    </p>
                              </li>
                              
                             
                            </ul>
                           </div>
                        </td>
                      </tr>
                    </table>

                    <div class="textcenter">
                      <p>
                        * The number besides each covered item indicates the number of units that are covered per covered appliance.
                      </p>
                    </div>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>
                    <div class="strongfont marbottom">
                      WE ARE HERE FOR YOU!
                    </div>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>

                    <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                      <tr>
                        <td>
                          <img src="img1" alt="#" width="100px"/>
                        </td>
                        <td>
                          <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                            <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h5>FILE CLAIM ONLINE</h5>
                                  <p>
                                    File Claims Online 24 hours a day - 7 days a week. We use modernized process ensuring you're updated every step of the way to manage claims efficiently. Visit your account at WWW.ELITEHW.COM or call (888) 222-1202.
                                  </p>
                            </li>
                          </ul>
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <img src="img2" alt="#" width="100px"/>
                        </td>
                        <td>
                          <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                            <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h5>PAY A SMALL COPAYMENT FEE</h5>
                                  <p>
                                    Easily pay copayment fees online, access and follow the process of your claim.
                                  </p>
                            </li>
                          </ul>
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <img src="img3" alt="#" width="100px"/>
                        </td>
                        <td>
                          <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                            <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h5>WE ASSIGN A CERTIFIED TECHNICIAN</h5>
                                  <p>
                                    Elite has a large network of vetted service providers to help you when you need
                          us the most. A certified technician will be heading your way as soon as possible.
                          All of our technicians are licensed and insured to perform services in your state.
                                  </p>
                            </li>
                          </ul>
                          
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <img src="img4" alt="#" width="100px"/>
                        </td>
                        <td>
                          <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                            <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h5>WE PROVIDE REPAIR OR REPLACEMENT</h5>
                                  <p>
                                    When things happen, we are here to take care of you. Our team truly understands
                          what you’re going through and we’ll treat your claim as if it were our own. We’ll
                          provide the support you need to get you back on your feet as quickly as possible.
                                  </p>
                            </li>
                          </ul>
                          
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <img src="img5" alt="#" width="100px"/>
                        </td>
                        <td>
                          <ul data-pdfmake="{&quot;markerColor&quot;:&quot;red&quot;,&quot;markerSize&quot;:&quot;20px&quot;}">
                            <li data-pdfmake="{&quot;listType&quot;:&quot;square&quot;,&quot;listSize&quot;:&quot;20px&quot;}">
                              <h5>90 DAYS WORKMANSHIP WARRANTY</h5>
                                  <p>
                                    Enhanced service backed by our 90-day workmanship warranty to ensure better
                          outcomes. If the same issue occurs again within 90 days, you are covered without
                          paying additional service fees.
                                  </p>
                            </li>
                          </ul>
                          
                        </td>
                      </tr>
                    </table>

                    <div data-pdfmake="{&quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <div class="strongfont marbottom" style="color: #fa6752;">
                      Home Service Agreement
                    </div>
                    <h5 style="margin-top: 0;" class="textcenter">
                      WWW.ELITE<span style="color: #fa6752;">HW</span>.COM
                    </h5>
                    <h4 class="textcenter">Agreement Section Guide</h4>

                    <table data-pdfmake="{&quot;layout&quot;:&quot;noBorders&quot;}">
                        <tr>
                          <td>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              I. Definitions
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              II. Agreement Fee; Term
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              III. Coverage Overview
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              IV. Repair Technician; Copayment Fee
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              V. Filing a Claim
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              VI. Appliance Coverage
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              VII. Systems Coverage
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              VIII. Optional Coverage; Coverage Details
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              IX. Other Coverage; Additional Fees
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              X. General and Partial Exclusions
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XI. Limitations on Liability
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XII. Multi-User Systems and Appliances
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XIII. Coverage Benefits
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XIV. Renewal; Transfer
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XV. Cancellation
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              XVI. Miscellaneous
                            </h4>
                            <h4 style="display: block; border-bottom:1px solid #fa6752; padding: 10px 0; font-weight: 600; color: #2d4f44;">
                              Supplemental State Specific Provisions
                            </h4>
                          </td>
                        </tr>
                    </table>

                    <p class="smallfontpara">
                      This Agreement provides You with coverage of the eligible items which you specifically identified and the level of coverage for each such eligible item which You purchased, as indicated in the Declaration of Coverage, and as more specifically described below. All coverage is subject to the terms and conditions of this Agreement, including but not limited to all applicable exclusions, limitations and restrictions. You can view your Declaration of Coverage online at any time by visiting our website at <a style="color: #fa6752;">www.elitehw.com</a>.
                    </p>
                    <p class="smallfontpara">
                      <b>NOTE:</b> In the event of an emergency pertains to gas,fire or has the potential to cause injury to You or anyone else present in or near your home,you should take all reasonable steps, including, but not limited to,vacating the premises and contacting the proper authority to ensure the safety of You and those present. Once the relevant authorities have determined that your home is safe to re-occupy, you must contact Elite Home Warranty immediately and inform them of this claim.
                    </p>

                    <h4>
                      I. DEFINITIONS
                    </h4>
                    <p class="smallfontpara">
                      The defined terms used in this Agreement include but are not limited to the following:
                    </p>
                    <p class="smallfontpara">
                      <b>A.</b> “Account Summary” means the part of this Agreement that provides account information including, but not limited to, the Overview of Your Selected Coverage details which identify the specific Covered Items and number thereof in each category which You chose to have Us cover hereunder for a Breakdown.
                    </p>
                    <p class="smallfontpara">
                      <b>B.</b> “Agreement” means this home Copayment which Elite has issued to you, the purchaser of this home Copayment, to provide coverage solely for the above-described Residence in respect to the coverages identified on the Account Summary, and which includes the Supplemental State Specific Provisions.
                    </p>
                    <p class="smallfontpara">
                      <b>C.</b> “Agreement Effective Date” or “Effective Date” means the date when this Agreement takes effect, which is 30 days after the date we receive your payment of the Agreement Fee. The 30-day waiting period does not apply and the “Agreement Effective Date” becomes the date we issue this Agreement to you only in the event that: (i) you provided a Valid Home Inspection Report to us prior to delivering payment of the Agreement Fee, (ii) you provided written proof to us that the Residence was covered under a home warranty issued by a different home warranty provider that was in force immediately prior to delivering payment of the Agreement Fee, or (iii) you are a Renewal Agreement Holder under Section II.B. No portion of this Agreement takes effect until the Agreement Effective Date.
                    </p>
                    <p class="smallfontpara">
                      <b>D.</b> “Agreement Fee” is the total purchase price which you paid to purchase the Agreement.
                    </p>
                    <p class="smallfontpara">
                      <b>E.</b> “Breakdown” means the mechanical failure of a covered item used in accordance with the manufacturer's guidelines, that is caused by ordinary wear and tear, or by a defect in materials or defective workmanship in the manufacturing process. A “Breakdown” does not include: (i) Cosmetic Damage, or (ii) any type of failure of a covered item that: (a) results from usage of the covered item in a manner prohibited by or inconsistent with the manufacturer's guidelines, (b) has been the subject of a manufacturer's recall related to the failure in issue, (c) is covered under any warranty issued by a manufacturer, distributor, retailer, builder, Repair Technician or other third party, including a warranty regarding workmanship, d) is covered under a service agreement or extended warranty, or (e) is due to any act, omission or other ground for which coverage is excluded or does not exist under this Agreement.
                    </p>
                    <p class="smallfontpara">
                      <b>F.</b> “Cosmetic Damage,” used in respect to a Breakdown, means one or more, or any combination of, scratches, dents, dings, discoloration, fading, marring, pitting, physical deterioration or other occurrences of superficial damage, irrespective of the actual or underlying causes, that principally affect the cosmetic appearance of the Covered Item, but which do not affect its functionality when used for its intended purpose under normal circumstances in a residential household setting.
                    </p>
                    <p class="smallfontpara">
                      <b>G.</b> “Covered Item” means an item which (i) was being used at the Residence when You purchased the Agreement, and continued to fully operate there in a problem-free manner and without any issues up through the Effective Date, (ii) must fully operate in a problem-free manner and without any signs of failure consistently for a minimum of 30 days prior to falling to function or showing any signs of failure, (iii) is expressly identified in a “What Is Covered” Section, (iv) is not expressly excluded by a “Not Covered” Section, (v) is not classified by the manufacturer as a commercial or commercial grade item or system, even if the system or appliance has been modified for residential use, and (vi) is not excluded from coverage under the General and Partial Exclusions Section, or due to the Limitations on Liability Section, a Coverage Limits Section or any other limitations in any Section. “Covered Item” does not include any item that was rebuilt, refurbished or remanufactured prior to being installed or used in the Residence, even if the item was being used in the Residence at the time a Valid Inspection Report was issued.
                    </p>
                    <p class="smallfontpara">
                      <b>H.</b> “Declaration of Coverage” means that portion of the Account Summary that lists the coverage you selected for the items which you chose to cover, and includes any additional charges you agreed to pay to increase the items to be covered or to increase the level of coverage for any such item(s), as of the date when you purchased this Agreement.
                    </p>
                    <p class="smallfontpara">
                      <b>I.</b> “Elite,” “EHW,” “We,” “Us” and “Our” mean the entity obligated to provide the coverage described under this Agreement, Elite Home Warranty LLC, 16192 Coastal Highway, Lewes, DE 19958.
                    </p>
                    <p class="smallfontpara">
                      <b>J.</b> “Exclusion” means any exclusion set forth in this Agreement that wholly or partially precludes coverage under this Agreement of a covered item which has failed for one or more reasons.
                    </p>
                    <p class="smallfontpara">
                      <b>K.</b> “Limitation” means any limitation set forth in this Agreement that wholly or partially limits coverage under this Agreement of a covered item which has failed for one or more reasons, and includes but is not limited to limitations imposed by the Annual Cap or Notes for a covered item or system.
                    </p>
                    <p class="smallfontpara">
                      <b>L.</b> “Maximum Coverage” means, subject to all other terms and conditions of this Agreement, the aggregate amount of claims which We will pay in a Term to perform any repairs or replacements or provide payment of any other expenses regarding each specific Covered item identified within: (i) Section VI regarding appliances, (ii) Section VII regarding systems, and (iii) Section VIII regarding Optional Coverage items covered under Section VIII.
                    </p>
                    <p class="smallfontpara">
                      <b>M.</b> “Maximum Category Coverage” means, subject to all other terms and conditions of this Agreement, the aggregate amount of claims which We will pay in a Term to perform any repairs or replacements or provide payment of any other expenses applicable to all Covered Items identified within: (i) Section VI regarding appliances, (ii) Section VII regarding systems, and (iii) Section VIII regarding Optional Coverage items covered under Section VIII.
                    </p>
                    <p class="smallfontpara">
                      <b>N.</b> “Repair Technician” means an independent professional technician who services one or more types of Covered Items used in a residential property, and currently holds the appropriate license, certification, designation or governmental authorization required to lawfully perform such services where the Residence is located.
                    </p>
                    <p class="smallfontpara">
                      <b>O.</b> “Residence” means the residential property located at the street address identified above and used by You and any lawful Transferee for residential purposes, and is limited to an existing or newly constructed: (i) single family home, which includes a manufactured home, condominium, townhome or mobile home under 3,000 square feet, and (ii) a dwelling in which you reside that has 3,000 square feet up to 10,000 square feet, or includes a guest unit, or multiple units, provided that (a) your application for this Agreement identifies these characteristics and has been approved by EHW, and (b) you have paid the Agreement Fee for the additional coverage of such characteristics.
                    </p>
                    <p class="smallfontpara">
                      <b>P.</b> “Section” means a section of this Agreement indicated on the Agreement Section Guide, and includes all terms and conditions thereunder, including but not limited to every What is Covered, Not Covered, Note, Important Note, Coverage Limits, Maximum Coverage, Maximum Category Coverage, and other similar term or condition.
                    </p>
                    <p class="smallfontpara">
                      <b>Q.</b> “Term” or “Term of Coverage” means (i) the twelve (12) month term of coverage that begins on the Agreement Effective Date for a First Term Agreement Holder under Section II.A.; (ii) the twelve (12) month term of coverage that begins on the anniversary of the Agreement Effective Date for a Renewal Agreement Holder under Section II.B.; or (iii) up to a 90 day term of coverage for a purchaser of seller’s coverage under Section II.C., which EHW at its discretion may renew for up to an additional 90 day term of coverage.
                    </p>
                    <p class="smallfontpara">
                      <b>R.</b> “You,” “Your” and “Agreement Holder” mean the original purchaser of this Agreement, and when applicable includes a transferee to whom this Agreement was timely transferred in accordance with the Agreement terms and conditions.
                    </p>
                    <h4>
                      II. AGREEMENT FEE; TERM
                    </h4>
                    <p class="smallfontpara">
                      <b>NOTE:</b> The Term and the Agreement Fee will vary for each Agreement Holder classification listed below. See your Declaration of Coverage for your specific Term and Agreement Fee.
                    </p>
                    <p class="smallfontpara">
                      <b>A.</b> First Term Agreement Holder. Upon our receipt of your payment of the Agreement Fee, a First Term Agreement Holder's Term of Coverage begins upon the Effective Date stated above and continues for one Term from that date. If a home inspection of the Residence was completed prior to the Effective Date, all covered items found at the time of the home inspection to have a defect or experienced a breakdown are excluded from coverage hereunder until proof of repair or replacement and payment of all related charges is provided to and received by us.
                    </p>

                    <p class="smallfontpara">
                      <b>B.</b> Renewal Agreement Holder. A Renewal Agreement Holder is an existing EHW Agreement Holder (i) whose Agreement EHW has offered to renew, subject to applicable requirements, and (ii) who has timely delivered payment of the Renewal Agreement Fee to EHW and met all other applicable requirements. A Renewal Agreement Holder's Term of Coverage begins upon expiration of the prior Term of Coverage and continues for one Term. Please see Section XIV. RENEWAL; TRANSFER, for additional terms and conditions which may apply.
                    </p>
                    <p class="smallfontpara">
                      <b>C.</b> Seller's Coverage. If You have listed the Residence for sale with a licensed realtor, have obtained and provided a Valid Home Inspection Report to Us prior to delivering payment of the Agreement Fee, and your purchase of the seller's coverage option is indicated by the Declaration of Coverage, then EHW will provide seller's coverage for up to the date of the sale closing or for 90 days from the Effective Date, whichever occurs first, as follows: (i) this coverage is limited to Covered Items for the following major systems - Air Conditioning, Heating, Electrical, Plumbing (excluding coverage for Plumbing stoppages), Water Heater, Refrigerator and Oven; (ii) this coverage is limited to repairs and parts required for the Breakdown of a covered item which can be repaired; (III) this coverage does not apply to the Breakdown of a covered item which cannot be repaired; (iv)the total amount which EHW will pay if one or more of these Covered Items experiences a Breakdown during this period is limited to fifteen hundred dollars ($1,500), in the aggregate, for expenses to access, diagnose or repair all of these Covered Items (with each claim being subject to all additional limitations under this Agreement, including but not limited to Sections XI. D.-G.); and (v) You pay a separate Service Call Fee of one-hundred dollars ($100) for each claim under this Section II.C. Upon EHW's review, and at its discretion, You may be able to renew seller's coverage under this Section II.C. for up to an additional 90 days. If the Residence ceases to be listed with a realtor, You must immediately pay the Service Agreement Fee to Us and become a First Term Agreement Holder under Section II.A. in order for You to have coverage for the Residence following the termination of the seller's coverage described in this Section II.C. If the sale of the Residence closes while seller's coverage under this Section II.C. remains in force, You must pay the Copayment Fee to Us and become a First Term Agreement Holder in order for Us to transfer to the buyer Your right as a First Term Agreement Holder to have the Residence covered under Section II.A. of this Agreement.
                    </p>

                    <h4>
                      III. COVERAGE OVERVIEW
                    </h4>

                    <p class="smallfontpara">
                      <b>A.</b> This Agreement is not an insurance policy or an Agreement of insurance. No coverage is provided hereunder for any covered item breakdown due in whole or in part to a casualty event (accident, fire, rain damage, flooding or other water intrusion, lightning, windstorm, Act of God) or government action (including but not limited to force majeure) or external peril of any kind, irrespective of whether such casualty event, governmental action or external peril is covered under an insurance policy. Please read your Agreement carefully.
                    </p>
                    <p class="smallfontpara">
                      <b>B.</b> Coverage under the Agreement includes only the items expressly stated as covered. The specific coverage and selections which you chose and purchased are indicated on the Declaration of Coverage, which is incorporated into this Agreement by reference. This Agreement provides no coverage for any item which is not expressly identified herein as a Covered Item.
                    </p>
                    <p class="smallfontpara">
                      <b>C.</b> If you submitted a Valid Home Inspection Report to us, coverage under this Agreement is not available for any item which the home inspector identified in the report as requiring for any reason either repair or replacement, but which you have not repaired or replaced as required prior to the Agreement Effective Date. Prior to the Agreement Effective Date, you must submit to us documentation that a required repair or replacement of an item has been performed in order for that item to be a Covered Item under this Agreement.
                    </p>
                    <p class="smallfontpara">
                      <b>D.</b> Coverage under the Agreement is always subject to all Exclusions, Limitations and other terms and conditions of this Agreement.
                    </p>
                    <p class="smallfontpara">
                      <b>E.</b> Coverage under this Agreement is provided only in respect to the Breakdown of a Covered Item during the Term.
                    </p>
                    <p class="smallfontpara">
                      <b>F.</b> For an item or system to be a Covered Item for purposes of a Breakdown, the item or system: 1. must be installed for diagnosis within the confines of the main foundation of the Residence or attached or detached garage; and 2. Must be a non-commercial grade item that is specified by the manufacturer for use in a residential application.
                    </p>
                    <p class="smallfontpara">
                      <b>G.</b> For a Breakdown, unless otherwise specified in this Agreement, EHW will repair or replace the covered item. EHW has the sole right to determine, according to the terms of this Agreement, whether a covered item will be repaired or replaced. When making repairs to a Covered Item, if original replacement parts are not reasonably available, EHW reserves the right to rebuild or repair existing parts or components and to install rebuilt parts or components. When replacing or repairing a Covered Item, EHW, when such are reasonably available, will pay to install replacement equipment and parts of similar features, capacity, and efficiency, and pay to provide replacement equipment and parts using the same or a similar make, model and color. EHW is not obligated to (i) match the brand or color of the equipment or parts which are replaced when such are not reasonably available; or (ii) match any feature of an existing item that does not contribute to the primary function of that item.
                    </p>
                    <p class="smallfontpara">
                      <b>H.</b> Under our cash payment policies and procedures regarding a Breakdown, EHW:
                    </p>

                    <ul class="smallfontpara">
                      <li>
                          1. In instances when you prefer to receive a cash settlement in lieu of having us repair or
                          replace the covered item, will pay you the total amount we approved to repair or replace the
                          covered item minus the cost incurred to diagnose the Breakdown.

                      </li>
                      <li>
                          2. in instances where the combined cost to diagnose and repair or replace is estimated to
                          exceed a stated Agreement dollar limit, will not provide repair or replacement services but will
                          instead pay an amount equal to the Agreement dollar limit minus the cost incurred to diagnose
                          the breakdown.

                      </li>
                      <li>
                          3. in instances beyond our control that may prevent us from providing a repair or replacement of
                          a covered item, may provide you cash in lieu of the repair or replacement services. The amount
                          will be based on what a consumer without this Agreement would pay after negotiating the best
                          price for such services in your area. These instances are when:
                      
                          <ul>
                              <li>
                                  (a) Following a repair or replacement regarding a Breakdown, an item or system
                                  would remain non-compliant with laws, regulations or code requirements;
                              </li>
                              <li>
                                  (b) An item has a covered breakdown unrelated to a manufacturer's recall on that
                                  item; or
                              </li>
                              <li>
                                  (c) An item is not repairable and a replacement item is no longer being
                                  manufactured or not otherwise available.
                              
                              </li>
                              <li>
                                  (d) The estimated total cost of diagnosis and repair or replacement exceeds
                                  the stated contract dollar limit, EHW will not provide repair or
                                  replacement services, but will pay an amount equal to the contract dollar
                                  limit minus the cost of diagnosing the malfunction.
                              </li>
                          </ul>
                      </li>
                      <li>
                          4. In some instances, EHW may give you the option to accept a cash payment in lieu of
                          receiving the repair or replacement services. The amount which we may offer will be based on
                          the amount EHW would expect to pay (which is substantially less than retail cost) for parts and
                          labor for covered items less the incurred cost of the Repair Technician's diagnosis. EHW is not
                          obliged to extend such an offer and you are under no obligation to accept such an offer
                          extended by us. If you accept such an offer, you are required to repair the item or provide a new
                          replacement and send the acceptable proof of your actual itemized costs to EHW before any
                          reimbursement amount will be paid.

                      </li>

                    </ul>

                    <p class="smallfontpara">
                      <b>I.</b> EHW will not repair or replace any item for a breakdown covered by a manufacturer,
                      distributor, retailer, builder, contractor, Repair Technician, Copayment or an
                      extended warranty.
                      

                    </p>
                    <p class="smallfontpara">
                      <b>J. </b> Coverage hereunder is solely available and provided for owned or rented residential
                      property used for residential purposes. This Agreement provides no coverage for
                      commercial property or any portion of residential property converted into or otherwise
                      used for a commercial purpose.
                    </p>

                    <h4>IV. REPAIR TECHNICIAN; COPAYMENT FEES</h4>

                    <p class="smallfontpara">
                      <b>
                          NOTE: The amount of your Copayment Fee and Special Copayment Fee is listed on your Declaration of Coverage pages.
                      
                      </b>
                    </p>
                    <p class="smallfontpara">
                      <b>A. Copayment Fee; Per Covered Item</b> . You are required to pay a Copayment Fee to Us for each Claim filed with EHW. If your Claim pertains to multiple Covered Items which experienced a Breakdown, you are required to pay a Copayment Fee to Us for each Covered item which has experienced a Breakdown.
                  
                    </p>
                    <p class="smallfontpara">
                      <b>B. Copayment Fee Waiver Option</b>. If the Declaration of Coverage indicates your Purchase Price included payment for a Copayment Fee Waiver, then we waive your obligation to pay the Copayment Fee with respect to the first three (3) Claims within the Term. The Copayment Fee Waiver does not apply to any Professional Grade Appliances and Equipment.
                  </p>
                  <p class="smallfontpara">
                      <b>C. You Select The Repair Technician</b>. If you select your own authorized Repair Technician, then: (i) EHW does not provide any guarantee as to the workmanship of the authorized Repair Technician whom you selected, so if any repair of a Covered Item performed by this Repair Technician fails for any reason during the Term, you must pay the Copayment Fees for any additional service call(s); (ii) EHW will pay the Repair Technician for labor at an hourly rate not to exceed the standard hourly rate for such trade in the county where the Residence is located; (iii) EHW will not pay any overtime or weekend or holiday hourly rate for Repair Technician labor, irrespective of the time or date when the Repair Technician performs services at the Residence; and (iv) you will be responsible for paying the Repair Technician any amount charged by the Repair Technician in excess of the amount EHW pays in accordance with the provisions of this Section IV.C. and all other applicable limitations or restrictions under this Agreement. 
                  </p>
                  <p class="smallfontpara">
                      <b>D. We Select The Repair Technician</b>.  If EHW selects the authorized Repair Technician to perform the service, EHW: (i) for up to 90 days after the date of service will guarantee the repairs performed by this Repair Technician; (ii) for any follow-up repair services required in respect to repairs guaranteed under Section IV.D.(i), will pay for any additional Copayment Fees charged for any related follow-up cliam(s) required in that period. You will be responsible for paying the Repair Technician any amount charged by the Repair Technician in excess of the amount EHW pays in accordance with the provisions of this Section IV.D.
                  
                  </p>
                  <p class="smallfontpara">
                      <b>E. Professional Grade Appliances - Special Copayment Fee</b>. EHW will charge a Special Copayment Fee in the amount of $150.00 per appliance for each claim on any covered optional items identified in section VIII and/or professional, luxury or special grade appliance, whether such was manufactured under one of the following brands or lines - Sub Zero, Viking, Wolf, Bosch, Miele, Bertazzoni, Dacor, Fisher & Paykel, Thermador, Thor, JennAir, BlueStar, Gaggenau, La Cornue or GE Monogram - or is included under a professional, luxury or special grade brand, collection or line made by a different manufacturer of professional, luxury or special grade appliances. The Special Copayment Fee is not waivable; however, whenever you pay a Special Copayment Fee pursuant to this Section IV.E. because your claim request involves a professional grade appliance, you will not be required to pay a separate Copayment Fee under Section IV.A. unless your claim request also involves one or more Covered Items that is not a professional grade appliance. 
                  </p>

                  <h4>V. FILING A CLAIM</h4>

                  <p class="smallfontpara">
                    <b>A .</b> EHW accepts service requests for claims 24 hours a day, 7 days a week. 
                  </p>

                    <p class="smallfontpara">
                      <b>B .</b> You must notify EHW as soon as you discover a potential breakdown, which notice
                      must be provided to us prior to expiration of the Term of Coverage. If you think a
                      Covered Item has experienced a Breakdown, please provide notice of your claim to us
                      by either: (i) going to our website at <a href="https://www.elitehw.com/" style="color: #fa6752;">www.elitehw.com</a>, or (ii) by calling us at (888) 222-1202 immediately.
                    </p>

                    <p class="smallfontpara">
                      <b>C .</b> We will not reimburse you for services performed without our prior approval of your 
      claim. You must timely pay all types of COPAYMENT FEES and Agreement Fees with respect 
      to each claim you file. EHW will not provide service for a new claim until you have paid 
      in full all past due COPAYMENT FEES and Agreement Fees for each prior claim. 

                  </p>
                  <p class="smallfontpara">
                      <b>D .</b> You may select your own authorized Repair Technician. 

                  </p>
                  <p class="smallfontpara">
                      <b>E .</b> If you do not select your own authorized Repair Technician, EHW will select an
      authorized Repair Technician to perform the service. The Repair Technician will contact
      you to schedule your service appointment, for service to be performed during normal
      business hours.

                  </p>
                  <p class="smallfontpara">
                      <b>F .</b> Under normal circumstances, service will commence within 24-48 hours after we
      receive your service request.
                  </p>

                  <p class="smallfontpara">
                    <b>G .</b> EHW will accept your request to expedite scheduling of non-emergency service only
                    when a Repair Technician is available. If the Repair Technician agrees to expedite
                    scheduling of a non-emergency service request, you may be required to pay an
                    additional fee.
                

                </p>
                      <p class="smallfontpara">
                          <b>H .</b> EHW will determine if a service constitutes an emergency and will make reasonable 
                          efforts to expedite emergency service. 
                      
  
                      </p>
                      <p class="smallfontpara">
                          <b>I .</b> EHW reserves the right to obtain a second opinion at its expense. In the event that
                          EHW informs you the potential breakdown is not covered under this Agreement, you
                          have the right to request a second opinion of the cause of the potential breakdown. You
                          must ask EHW for a second opinion from another Repair Technician at your expense
                          within 7 days from the date when EHW informs you the potential breakdown is not
                          covered. In the event that the outcome of the second opinion is different than the first
                          opinion, then EHW may, in its discretion, decide whether and to what extent coverage
                          will be made available under this Agreement.
                      </p>
                      <p class="smallfontpara">
                        <b>
                            Sections VI, VII and VIII - Categories of Coverage: 
                        </b>
                      </p>
                      <p class="smallfontpara"> Appliances; Systems; Optional Items</p>
                      <h4>
                        VI. APPLIANCES - COVERAGE DETAILS
                      </h4>

                      <p class="smallfontpara">
                        <b>
                            IMPORTANT NOTES:
                        </b>
                      </p>
                      <p class="smallfontpara">
                          
                              MAXIMUM CATEGORY COVERAGE - Under this section, the liability of EHW is limited
                              to paying in the aggregate up to $7,000 per Term for all Breakdowns which could be
                              covered under this Section, unless additional coverage is purchased and noted on the
                              Account Summary.
                              
                         
                      </p>
                      <p class="smallfontpara">
                        
                            MAXIMUM COVERAGE PER COVERED APPLIANCE - The Maximum Coverage noted
                            below for each type of appliance applies to a single unit of the covered appliance in
                            issue. If the Account Summary indicates that You purchased coverage for two (2) or
                            more units of the covered appliance in issue, then the MAXIMUM COVERAGE
                            indicated below applies to each unit of the total number of items indicated on the
                            Account Summary, which amount may not exceed the Maximum Category Coverage.
                            <b>SPECIAL GRADE APPLIANCES</b> - See Section IV.E. regarding the Special Copayment
                            charged for every trade service request that pertains to a claim on any professional
                            grade appliance.
                      </p>
                      <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[80,20,80,20], &quot;thickness&quot;:2}"></div>
                      <h4 style="color: #fa6752; font-size: 25px;">
                        COVERED APPLIANCES:
                      </h4>
                      <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[10,10,10,10], &quot;thickness&quot;:2}"></div>
                      <h5>REFRIGERATOR INCLUDING ICE MAKER & WATER DISPENSER</h5>

                      <p class="smallfontpara">
                        <b >WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including
                        integrated freezer, ice maker, ice dispenser, water dispenser, temperature control, control board, power
                        supply board, defrost control board, compressor, thermistors, condensers, evaporators, fan motors,
                        timers, thermostats, wiring, fans, dampers, and damper motors, except:
                    </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> water lines | freestanding freezer | multi media centers | wine chillers.
                        

                    </p>
                    <p class="smallfontpara">
                        <b>NOTE:</b> If any ice maker(s), ice dispenser(s) or water dispenser(s) or related mechanism(s) must be
                        repaired or replaced due to a Breakdown, the liability of EHW is limited to paying in the aggregate up to
                        $150 per Term combined for access to, diagnosis, repair, or replacement of all such ice maker(s), ice
                        dispenser(s), water dispenser(s) or related mechanism(s); Contract Holder is responsible for payment of
                        any additional expenses relating to access, diagnosis, repair or replacement all ice maker(s), ice
                        dispenser(s), water dispenser(s) or related mechanism(s).

                    </p>
                    <p class="smallfontpara">
                        <b>MAXIMUM COVERAGE:</b> $2,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5>CLOTHES WASHER</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                    boards, thermostats, motors, pumps, wiring, belts, relays and switches, water valve, agitator,
                    transmission, clutch and brake assemblies, coupler, tub bearings, tub seals, timer, drain pumps, pressure
                    sensor, hoses, pulleys, igniters, fuses, and gas valve, except:</p>
                    <p class="smallfontpara">
                              <b>NOT COVERED:</b> damage of clothing | removable mini tubs | leveling and balancing | lint screens |
                              leveling and balancing | soap dispenser. 
                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $1,000 per Term.</p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>CLOTHES DRYER</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control boards, thermostats, motors, blower wheel, timer, pumps, wiring, burners and heating elements, pulleys, igniters, fuses, drum rollers, glides, drum bearing, thermistors, pilot assemblies, flame sensors, and gas valve, except:</p>
                    <p class="smallfontpara">
                    <b>NOT COVERED:</b> damage of clothing | venting | leveling and balancing | lint screens | leveling and
                    balancing. 
                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $1,000 per Term.</p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>RANGE/OVEN/COOKTOP</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        boards, heating elements, burners, cooking elements, thermostats, wiring, gas valves, control panel,
                        control overlays, temperature sensor, igniters and broilers, except: </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> venting | rotisseries | downdrafts | range exhaust hood | self-cleaning mechanism. 
                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $1,500 per Term.</p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>DISHWASHER</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        boards, motors, heating elements, water valves, drain pump, hosed, drain lines, float sensor, dishwasher
                        tub, washarm, spray arm, and fill valves, except: 
                        </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> soap dispensers | effectiveness of cleaning.

                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $1,000 per Term.</p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5>BUILT-IN MICROWAVE OVEN</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        board, transformer, touch and control panel, magnetron, capacitor, diode, coupler, turntable motor, cooling
                        fan, except:</p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> portable units | combo unit | turn table | interior lining. 
                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $500 per Term.</p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5>GARBAGE DISPOSAL</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, 
                        including motors, blades, wiring, casing and switches, except:</p>

                        <p class="smallfontpara">
                            <b>NOT COVERED:</b> malfunctions caused by bones, glass, or foreign objects other than food.
        
                        </p>    

                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $500 per Term. </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5>CEILING FANS</h5>

                    <p class="smallfontpara"><b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including motors,
                        switches, bearings, and controls, except: </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> fans | blades | shutters | range exhaust fans |shutters | lighting. 
                    </p>
                    <p class="smallfontpara"><b>MAXIMUM COVERAGE:</b> $500 per Term. </p>


                    <h4>
                      VII. SYSTEMS COVERAGE - COVERAGE DETAILS 
                    </h4>
                    <h5>IMPORTANT NOTES:</h5>
                    <p class="smallfontpara">
                      MAXIMUM CATEGORY COVERAGE - Under this Section, the liability of EHW is limited to paying in the
                      aggregate up to $8,000 per Term for all Breakdowns which could be covered under this Section, unless
                      additional coverage is purchased on the Account Summary. MAXIMUM COVERAGE PER COVERED
                      SYSTEM – The Maximum Coverage noted below for each type of system applies to a single unit of the
                      covered system in issue. If the Account Summary indicates that You purchased coverage for two (2) or
                      more units of the covered system in issue, then the MAXIMUM COVERAGE indicated below applies to
                      each unit of that type of system indicated on the Account Summary, which amount may not exceed the
                      Maximum Category Coverage.
                    </p>
                    <h5>
                      AIR CONDITIONING, HEATING and HVAC SYSTEM* NOTES: 
                    </h5>
                     <p class="smallfontpara">
         
                         If the Residence: (a) does not have an HVAC system serve as its primary heating and cooling system, we
                         provide the standard coverage you separately selected, paid the additional charge for, and which appears
                         on the Account Summary for (i) the Residence's primary gas, oil or electric heating unit and ductwork, or
                         (ii) the Residence's primary air conditioning unit and ductwork, or (iii) both (i) and (ii); or (b) does have an
                         HVAC system, we provide standard coverage for the HVAC system, provided, however, that we provide
                         no coverage for any other air conditioning or heating equipment or ductwork that heats or cools any part
                         of a floor within the Residence, unless you separately selected such additional coverage, paid the
                         additional charge for such coverage, and such coverage appears on the Account Summary.
                     
                     </p>

                     <p class="smallfontpara">
                      Coverage is available on HVAC systems or Heating and Air Conditioning units having a capacity of up to
                      five (5) tons. Where covered repairs require access to Air Conditioning and Heating ductwork, EHW will
                      provide access to ductwork only through unobstructed walls, ceilings or floors, and will return access
                      openings to a rough finish. 
          
                  </p>
                  <p class="smallfontpara">
                    If the Air Conditioning and Heating ductwork is accessible only through a concrete floor, wall or ceiling,
                    EHW will pay a total of up to $1,000 per Term to access, diagnose, repair or replace such ductwork,
                    including returning access openings to a rough finish. During the Term, EHW will pay for access,
                    diagnosis, and replacement related to necessary or required Heating and Air Conditioning system
                    efficiency and other upgrades except: (1) costs associated with plenums and refrigerant line sets, and (2)
                    any other Heating and Air Conditioning-specific limitations and exclusions in your Agreement.
                    *When the word “primary” is used in respect to the air conditioning and heating system for a heated
                    and/or cooled floor of the Residence, “primary” means: (a) the HVAC system, if it heats and cools any part
                    of that floor, or (b) the main source of cooling and/or heating for a floor, if there is no HVAC system that
                    heats or cools any part of that floor.
                
                  </p>

                  <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[80,20,80,20], &quot;thickness&quot;:2}"></div>
                  <h4 style="color: #fa6752; font-size: 25px;">
                    COVERED SYSTEMS:
                  </h4>


                  <h5>AIR CONDITIONING INCLUDING DUCTWORK</h5>
                  <p class="smallfontpara">
                    <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including main
                    control board, thermostats, compressors, motors, condensers, casings, pumps, transformers, capacitors,
                    contactors, pressure switches, belts, pulleys, drain lines, thermistor, elements, exchangers, fuses,
                    electronic circuits, rectifiers, evaporator coils, condenser coils, compressors, copper line leak repair,
                    blower wheels, blower motors, defrost elements and freon*, except:
                </p>

                <p class="smallfontpara">
                  <b>NOT COVERED:</b> maintenance and cleaning | humidifiers | coils | disconnect boxes | condenser casings | condensate pumps | thermal expansion tanks | registers and grills | zone controllers | outside or underground piping for geothermal and/or water units | well pump, and well pump components for geothermal and/or water units | improperly sized units | support equipment.
              </p>

          <p class="smallfontpara">
              <b>TYPE OF SYSTEMS COVERED:</b> electric central air conditioning unit | heat pump | duct systems | wall air
              conditioners | mini splits HVAC System (if applicable).
          </p>   


          <p class="smallfontpara"><b>TYPE OF SYSTEMS NOT COVERED:</b> portable units | gas units | water towers | humidifiers | chillers | evaporative coolers | air cleaners | lithium units | window units | geothermal | radiant units | solar units |
          packaged units.</p>
          <p class="smallfontpara">
              <b>*FREON COVERAGE:</b> EHW liability hereunder is limited to paying in the aggregate up to $150 per Term for refrigerant for all Breakdowns which could be covered under this Section, unless additional coverage
              is purchased and noted herein.
          </p>
          <p class="smallfontpara">
              <b>NOTE:</b> Air Conditioning and Cooling Systems must be serviced annually and to maintain the required regular maintenance for the unit to function effectively and efficiently.
          </p>
          
          <p class="smallfontpara">
              <b>MAXIMUM COVERAGE:</b> $3,000 per Term. If the Air Conditioning system is part of an HVAC system, the Maximum Coverage under this category of system is $3,000 per Term.
          </p>

          <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

          <h5>HEATING INCLUDING DUCTWORK</h5>
                   <p class="smallfontpara">
                            <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including main
control board, thermostats, compressors, motors, condensers, pumps, transformers, capacitors,
contactors, pressure switches, coils, belts, pulleys, relays, drain lines, thermistor, elements, exchangers,
fuses, electronic circuits, burners, controls, ignitors, inducer motors, blower fan motors, limit switches,
heat exchangers, furnace control boards, temperature sensors, burner assemblies, pilot assemblies, and
fan blades, except:
                        </p>
                        <p class="smallfontpara">
                            <b>NOT COVERED:</b> maintenance and cleaning | humidifiers | zone controllers | rectifiers | fuel storage tanks
| concrete encased or inaccessible ductwork | cracked heat exchangers | thermal expansion tanks |
insulation | insulated ductwork | asbestos | evaporator coil pan | dampers | valves and key valves |
inaccessible water and steam lines | backflow preventers | registers and grills | vents | flues, and liners |
cleaning and re-lighting of pilots | outside or underground piping for geothermal and/or water units |
mismatched systems | improperly sized units.
                        </p>
                        <p class="smallfontpara">
                            <b>TYPE OF SYSTEMS COVERED:</b>  forced air systems | electric baseboards | hot water units | boilers |
steam circulating units | wall mounted heaters | heat pumps | floor furnaces | mini splits HVAC system (if
applicable).
                        </p>

                        <p class="smallfontpara">
                            <b>TYPE OF SYSTEMS NOT COVERED:</b> portable units | geothermal | radiant units | solar units | packaged
units | chimneys | fireplaces | wood, grain or pallet heating units | window units | humidifiers | air cleaners |
individual space heaters | electric baseboard heat unless primary heating system | pellet stoves | heat
lamps.
                        </p>

                        <p class="smallfontpara">
                            <b>NOTE:</b> Heating Systems must be serviced annually and to maintain the required regular maintenance for the unit to function effectively and efficiently.
                        </p>

                        <p class="smallfontpara">
                            <b>MAXIMUM COVERAGE:</b> $3,000 per Term. If the Heating system is part of an HVAC system, the
Maximum Coverage under this category of system is $3,000 per Term.
                        </p>
                        <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                        <h5>ELECTRICAL SYSTEM</h5>
                    <p class="smallfontpara">
                        <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including wiring, main panels, sub-panels, switches, breakers, receptacles, junction boxes, ground fault interrupters, outlets, and built-in bathroom exhaust fans, except:
                    </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> intercom and communication systems | meter boxes | faceplates | dc components |
                        fixtures | attic exhaust fans | wire tracing | rerunning of new wiring | auxiliary | alarm systems | smoke
                        detectors | doorbells | sub panels | upgrading existing outlets | telephone systems | telephone wiring |
                        energy management systems | Solar Systems |
                    </p>
                    <p class="smallfontpara">
                        <b>MAXIMUM COVERAGE:</b> $1,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>PLUMBING</h5>
                    <p class="smallfontpara">
                        <b>WHAT IS COVERED:</b> Interior plumbing lines including leaks/breaks of any kind, water lines, waste lines,
                        vent lines, valves, pressure regulators, toilets and related mechanisms, toilet wax ring seals, tubs,
                        diverters, angle stops, risers, gate valves, built-in bathtub whirlpool motor/pump assemblies, except:
                       </p> 
                       <p class="smallfontpara">
                        <b>NOT COVERED:</b> hose bibs | basket strainers | showers | bathtubs | sinks | toilet seats and leads | jets |
                        saunas or steam rooms | storage tanks | holding tanks | grouting | caulking | water filtration system* |
                        septic tanks* | sump pumps* | well pumps* | ejector pumps* | access through roof vents | gas lines | water
                        closets | slab leaks | drum traps | flange | fixtures and cartridges | baskets and strainers | popup
                        assemblies | cracked porcelain | shower enclosures and base pans | roman tubs | bathtub drain
                        mechanisms | pressure regulators and valves | flood control or check valves | caulking | filtration systems
                        | iron breakers | water pressure | holding and storage tanks | saunas and steam rooms | jetting.
                       </p>
                       <p class="smallfontpara">
                        <b>NOTE:</b> Where covered repairs require access to plumbing, EHW will provide access to plumbing only
                        through unobstructed walls, ceilings or floors, and will return access openings to a rough finish. If any
                        toilet tank, toilet bowl or related mechanism(s) must be repaired or replaced due to a Breakdown, the
                        liability of EHW is limited to paying in the aggregate up to a total of $250 per Term combined with respect
                        to each one (1) toilet, which limit includes expenses for access, diagnosis, repairs or replacement;
                        Contract Holder is responsible for payment of any additional expenses relating to access, diagnosis,
                        repair or replacement with respect to each toilet.
                       </p>
                       <p class="smallfontpara">
                        <b>MAXIMUM COVERAGE:</b> $1,000 per Term.
                       </p>

                       <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                       <h5> PLUMBING STOPPAGES</h5>
                       <p class="smallfontpara">
                           <b>WHAT IS COVERED:</b> Plumbing stoppages including stoppages of any kind, water lines, waste lines, vent
                           lines, clearing of toilet/shower/bathtub and sink stoppages, clearing of mainline drain and sewer
                           stoppages through an accessible cleanout up to 100 feet from access point, Clearing of lateral drain line
                           stoppages up to 100 feet from access point including accessible cleanout, p-trap, drain or overflow
                           access points, except: 
                       </p>
                       <p class="smallfontpara">
                           <b>NOT COVERED:</b>  Interior and/or exterior stoppages caused by collapsed, damaged or broken drain, vent
                           or sewer lines outside the residence's main foundation | lines broken, infiltrated or stopped by roots or
                           foreign objects, even if within the Residence's main foundation | stoppages and clogs that cannot be
                           cleared by cable or snake | gas lines | water closets slab leaks | costs to locate or access cleanouts not
                           found or inaccessible, or to install cleanouts | access through roof vents.
   
   
                       </p>
                       <p class="smallfontpara">
                           <b>NOTE: </b>
                           Where covered repairs require access to plumbing, EHW will provide access to plumbing only
   through unobstructed walls, ceilings or floors, and will return access openings to a rough finish.
                       
   
                       </p>
                       <p class="smallfontpara">
                           <b>
                               MAXIMUM COVERAGE:
                           </b>
                           $500 per Term
                       </p>

                       <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                       <h5> WATER HEATER</h5>
                    <p class="smallfontpara">
                        <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including tankless
                        water heaters, circulating pumps, control board, thermostats, heating elements, gas valves, safety valve,
                        pressure switches, vent pipes, vent lines, thermocouple, burner and pilot assembly, ignition module and
                        Igniter, except: 
                    
                    </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b>  hot water dispensers | pressure valves | base pans | drain pans and drain lines | color or
                        purity of water | flues | solar components | lime buildup | Sediment build-up | insulation and insulation
                        blankets | magnesium rod failure.   
                    
            
            
                    </p>
            
                    <p class="smallfontpara">
                        <b>
                            MAXIMUM COVERAGE:
                        </b>
                        $2,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>GARAGE DOOR OPENER</h5>
                    <p class="smallfontpara">
                        <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        boards, motors, relays, and switches, except:
                    </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> capacitors | drive trains | track assembly | push arm | door hardware | axle bolts |
                        keypad | sensors | wall buttons | remote controls and similar devices.


                    </p>

                    <p class="smallfontpara">
                        <b>
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.
                    </p>


                    <h4>
                      VIII. OPTIONAL COVERAGE - COVERAGE DETAILS
                    </h4>

                    <h5>
                      IMPORTANT NOTES:

                    </h5>
                    <p class="smallfontpara">
                     
                          MAXIMUM CATEGORY COVERAGE - Under this section, the liability of EHW is limited 
                          to paying in the aggregate up to $5,000 per Term for all Breakdowns which could be 
                          covered under this Section, unless additional coverage is purchased and noted on the 
                          Account Summary. 
                      
                     
                    </p>
                    <p class="smallfontpara">
                            MAXIMUM COVERAGE PER COVERED ITEM OR SYSTEM - The Maximum 
                            Coverage noted below for each type of item or system applies to a single unit of the 
                            covered item or system in issue. If the Account Summary indicates that You purchased 
                            coverage for two (2) or more units of the covered item or system in issue, then the 
                            MAXIMUM COVERAGE indicated below applies to each unit of that type of item or 
                            system indicated on the Account Summary, which amount may not exceed the 
                            Maximum Category Coverage.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[80,20,80,20], &quot;thickness&quot;:2}"></div>

                    <h4 style="color: #fa6752;">
                      COVERED OPTIONAL ITEMS:
                    </h4>

                    <h5>WELL PUMP</h5>

                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including well
                      pump, motor, pressure switch, seals, controls, impellers, electrical and plumbing lines, except: 
                  

                  </p>
                  <p class="smallfontpara">
                      <b>NOT COVERED:</b> booster pumps | pressure tanks | gauges | well casings | tempering | joint wells | check
                      and relief valve | geothermal well systems | well drilling | re-drilling of wells | water source heat pumps |
                      holding or storage tanks | charges necessary to gain access and/or locate the well pump.
                  </p>

                  <p class="smallfontpara">
                      <b>
                          MAXIMUM COVERAGE:
                      </b>
                      $750 per Term.

                  </p>

                  <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                  <h5>SEPTIC SYSTEM</h5>
                    <p class="smallfontpara">
                        <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including sewage
                        ejector, aerobic pump, jet pump, plumbing lines, septic pumping*, mainline stoppages that can be cleared
                        without excavation, and power supply, except: 

                    </p>
                    <p class="smallfontpara">
                        <b>NOT COVERED:</b> broken or collapsed sewer lines | leach beds | leach lines | lateral lines | cesspools |
                        chemical treatments | cost of finding or gaining access to the septic tank or sewer hook-ups | holding or
                        storage tanks | disposal of waste | sewer hook-ups | tanks | mechanical pumps/systems | insufficient
                        capacity.
                    </p>
                    <p class="smallfontpara">
                        <b>NOTE:</b> Septic system pumping is only covered once during the original first Term. Does not include access to and/or digging of covered systems.
                    </p>
                    <p class="smallfontpara">
                        <b>
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>SUMP PUMP</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard
                        groundwater sump pumps, switches, evacuation lines, and receptacles, except: 

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> lack of capacity | battery backup systems | backflow preventers | check valves | piping
                        modifications for new installs | portable pumps | grinder pumps | sewage ejector | piping modifications.
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5>GRINDER PUMP</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard
                        residential grade grinder pump located within perimeter of the home, power supply and plumbing lines,
                        motors, capacitors, impeller, mechanical seal, rotors, pump assembly, level controls, and control panel,
                        except: 

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> lack of capacity | battery backup systems | blades | basins | alarms | portable pumps |
                        sump pumps | sewage ejector | backflow preventers | piping modifications.
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.

                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5>EJECTOR PUMP</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard
                        residential grade grinder pump located within perimeter of the home, power supply and battery-operated
                        plumbing lines, motors, capacitors, impeller, mechanical seal, rotors, pump assembly, level controls, and
                        control panel, except:

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> lack of capacity | battery backup systems | blades | basins | alarms | portable pumps |
                        grinder pumps | backflow preventers | piping modifications. 

                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.

                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> POOL AND SPA EQUIPMENT</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform the full functionality of the pool or/and
                        spa mechanical system, including above ground accessible piping, pumping system, plumbing system,
                        heating system, filtration system, electrical system, primary circulated pump and motor, blower motor,
                        heaters, timers, plumbing pipes, wiring, pressure gauges, housings, impellers, and laterals, inground and
                        above ground pools and spas, except:

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> portable pools | portable spas | structural defects | underground components |
                        computerized control board | timer | heat pump | leaks | liners | pool/spa cover and related equipment |
                        cover motors | waterfalls | fountains | lights | jets | pool sweeps | fuel storage tanks | disposable filtration |
                        cracked or corroded casings | grids | cartridges | gaskets | switches | relays | cleaning equipment |
                        skimmers | popup heads | chlorinators | ionizers | light fixtures | maintenance.

                    </p>
                    <p class="smallfontpara">
                      <b class="boldfont">NOTE:</b> Both pool and spa equipment are covered if they share components and parts. If not, then only
                      the pool or the built-in spa is covered. 
                    </p>
                    

                    <p class="smallfontpara">
                        <b>
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> CENTRAL VACUUM</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, blower fan; blower
                        fan motor, control panel, dust collector, dust collect tank, and capacitors, except: 
                    

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b>  blockages | accessories | ductwork | piping | nozzles | hoses | access.
                    </p>

                    <p class="smallfontpara">
                        <b>
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> WATER FILTRATION SYSTEM</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard
                        residential grade water filtration system located within the perimeter of the home, power supply, and all
                        associated plumbing lines, check valves, fittings, drain flow restrictors, pressure booster pumps, reverse
                        osmosis membrane, and filters, except:
                        

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> filters | sediment buildup | lime buildup | none electric powered systems | color or purity
                        of the water pressure regulators | water filters pitchers | sediment build up | pressurized storage tanks |
                        water testing kits | insufficient water pressure | excessive water pressure.
                        

                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> PLUMBING FIXTURES</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including kitchen
                        faucets, bathroom faucets, shower heads, shower handles, water leaks and assembly parts, except:

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> insufficient water pressure | excessive water pressure.


                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.

                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> FREESTANDING FREEZER</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        board, compressor, condensers, evaporators, fan motors, timers, thermostats, wiring, racks, shelves, door
                        seals, door alarms and wire harness, except:

                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> touch panel | filters | leaks.


                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.

                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> FREESTANDING ICE MAKER
                    </h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including ice
                        maker, ice dispenser, water dispenser, control board, compressor, condensers, evaporators, thermostats,
                        and power supply, except:
                        


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> touch panel | water lines.

                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.

                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> LAWN SPRINKLER SYSTEM</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including timers,
                        valves, stoppages, water lines and power supply, except:
                        
                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> seasonal maintenance | hydraulic systems | heads | digging | insufficient water pressure
                        | excessive water pressure | breakdown resulting from a weather condition.
                        
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.


                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> SEPARATED SPA</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform the full functionality of separated spa
                        mechanical system, including above ground accessible piping, pumping system, plumbing system,
                        heating system, filtration system, electrical system, primary circulated pump and motor, blower motor,
                        heaters, plumbing pipes, wiring, pressure gauges, housings, impellers, and laterals, in-ground and above
                        ground spas, except:
                        


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> portable spas | structural defects | underground components | computerized control
                        board | timer | heat pump | leaks | liners | spa cover and related equipment | cover motors | waterfalls |
                        fountains | lights | jets | sweeps | fuel storage tanks | disposable filtration | cracked or corroded casings |
                        grids | cartridges | gaskets | switches | relays | cleaning equipment | skimmers | popup heads |
                        chlorinators | ionizers | light fixtures | maintenance.



                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.


                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> JETTED/HOT TUB</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform the full functionality of the jetted/hot tub mechanical system, including above ground accessible piping, pumping system, plumbing system, heating system, electrical system, primary circulated pump and motor, blower motor, heaters, plumbing pipes, and pressure gauges, except:
                        


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> portable tubs | structural defects | underground components | computerized control board | timer | heat pump | leaks | liners | lights | Suctions | jets | cracked or corroded casings | cleaning equipment | popup heads | light fixtures | maintenance.



                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term


                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> CENTRAL VACUUM</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, blower fan; blower fan motor, control panel, dust
collector,dust collect tank,and capacitors,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> blockages | accessories | ductwork | piping | nozzles | hoses | access.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $500 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> WATER FILTRATION SYSTEM</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard residential grade water filtration
system located within the perimeter of the home, power supply, and all associated plumbing lines, check valves, fittings, drain flow
restrictors,pressure booster pumps,reverse osmosis membrane,and filters,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> filters | sediment | buildup | lime | buildup | none electric powered systems | color or purity of the water pressure regulators |
water filters pitchers | sediment build up | pressurized storage tanks | water testing kits | insufficient water pressure |excessive water pressure.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $500 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> PLUMBING FIXTURES</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including kitchen faucets, bathroom faucets, shower
heads,shower handles,water leaks and assembly parts,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> insufficient water pressure | excessive water pressure.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $500 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> FREESTANDING FREEZER</h5>
                    <p class="smallfontpara">
                     <b>WHAT IS COVERED:</b>  All components and parts needed to perform its full functionality, including control board, compressor, condensers,
evaporators,fan motors,timers,thermostats,wiring,racks,shelves,door seals,door alarms and wire harness,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> touch | panel | filter | leaks.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $1,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> FREESTANDING ICE MAKER</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including ice maker, ice dispenser, water dispenser,
control board,compressor,condensers,evaporators,thermostats,and power supply,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> touch panel | water lines.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $500 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> LAWN SPRINKLER SYSTEM</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including timers, valves, stoppages, water lines and
power supply,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> seasonal maintenance | hydraulic systems | heads | digging | insufficient water pressure | excessive water pressure |
breakdown resulting from a weather condition.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $750 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> SEPARATED SPA</h5>
                    <p class="smallfontpara">
                      <b>WHAT IS COVERED:</b> All components and parts needed to perform the full functionality of separated spa mechanical system, including
above ground accessible piping, pumping system, plumbing system, heating system, filtration system, electrical system, primary
circulated pump and motor, blower motor, heaters, plumbing pipes, wiring, pressure gauges, housings, impellers, and laterals, in-
ground and above ground spas,except:
                    </p>
                    <p class="smallfontpara">
                      <b>NOT COVERED:</b> portable spas | structural defects | underground components | computerized control board | timer | heat pump | leaks |
                      liners | spa cover and related equipment | cover motors | waterfalls | fountains | lights | jets |sweeps | fuel storage | tanks | disposal
                      filtration | cracked or corroded casings | grids | catriges | gaskets | switches | relays | cleaning equipment | skimmers | popup heads |
                      chlorinators | ionizers | light fixtures | maintenance.
                    </p>
                    <p class="smallfontpara">
                      <b>MAXIMUM COVERAGE:</b> $750 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> GENERATOR</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including engine,
                        motor, control board, control panels, alternator, stators, rotors, fuel pumps, fuel injector, voltage regulator,
                        radiators, water pumps, air pumps, condenser, capacitors, wiring, switches, breakers, receptacles, axles,
                        and battery, except:
                        


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> leased equipment | fuels including gas, diesel, liquid propane, propane gas or natural
                        gas | circuit overload | belts | chargers | pads | main assembly and frames | filter nozzles | fuel filters |
                        coolants | maintenance | loss and/or damage arising out of power failure, power surge, flood and/or fire.
                    
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $750 per Term.


                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> SWAMP COOLER</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including motor,
                        shaft bearings, motor pulley, water pump, blower pulley, v-belt, wire connection box, and float valve,
                        except:
                     </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> drain and overflow tube | evaporative pads | distribution tubing | circuit overload | belts |
                        loss and/or damage arising out of power failure, power surge, flood and/or fire.
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.
                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> WINE COOLER</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including control
                        boards, compressor, condensers, temperature switches, circuit boards, control panel, exhaust fans,
                        thermal plates, evaporator coil, evaporators, fan motors, timers, thermostats, and wiring, except:


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> keys and/or locks | refrigerant | line restrictions | interior thermal shell | beverage
                        spoilage | multi media centers | panels | cabinetry.


                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.


                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> WATER SOFTENER

                    </h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform its full functionality, including standard
                        residential grade water filtration system located within the perimeter of the home, power supply, and all
                        associated plumbing lines, central head assembly, and multi-level/twin softeners, except:
                        


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> odor control | iron filtration components and systems | discharge drywells | inadequate
                        pressure
                        | tanks | recharge | regeneration | sediment buildup | lime buildup | none electric powered systems | color
                        or purity of the water | insufficient water pressure | excessive water pressure.
                    
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $500 per Term.


                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> ELECTRONICS</h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> One television; including all components and parts needed to perform its full
                        functionality, screens, chassis, motherboard, power board, power supply modules, remote receiving
                        board, transfer boards, reflector plates, diffuser plate, diffuser film, IR Board, IP BOard, internal speakers,
                        and LED bars, except not covered and one desktop and/or laptop computer that is principally used for
                        personal purposes within the perimeter of the home, including all components and parts needed to
                        perform its full functionality, motherboards, monitors, visual display unit (VDU), central processing unit
                        (CPU), graphics processing unit (GPU), video cards, graphic cards, random access memory (RAM), solid
                        state drive (SSD), Hard Disk Drive (HDD), power supply unit (PSU), and cooling system (fan and fan
                        motor), except:


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> remote controllers | HDMI cables | misuse, abuse or physical damage | analog or digital
                        antennas | projectors and/or projector screens | CRT televisions | cable boxes | power cables | wall
                        mounts | stands or stand bases | external speakers including surround sound system, sound bar,
                        amplifier, subwoofers etc | keyboards and/or keys | mouses | external speakers | auxiliary cables |
                        ethernet cables | computer covers | laptop carrying cases | virus protection software | virus related failures
                        | software upgrades | cameras | cable modems | routers | printers | scanners | fax machines | software
                        failures, whether due to a virus or not | power cord | remote control | screen | cosmetic damage |
                        accidental damage.
                        

                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $1,000 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> SERVICE LINE

                    </h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b>  All components and parts needed to perform the full functionality of the sewer
                        system and water line, including locating the blockage or collapse, locating a leak, excavation to expose
                        pipe, pipe replacement or repair, repair or replacement of seals and joints, unblocking, fitting external
                        valves, fusing, welding, pipe cutting, backfilling of areas disturbed by repairs, restoration of your
                        pavement, yard, or landscaping disturbed or excavated as part of a covered repair on your property.


                    </p>


                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $3,000 in total coverage per Term for repair and/or replacement, up to maximum
of 2 occurrences per Term with a limit of up to $1,500 for each occurrence for repair and/or replacement.

                    </p>
                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> LIMITED ROOF LEAK REPAIR SERVICE</h5>

                    <p class="smallfontpara">
                      <b class="boldfont">WHAT IS COVERED:</b> Limited Roof Patching Repairs required to patch a roof when necessary to stop a
                      resulting interior leak in the occupied living area of the Residence directly beneath the roof, or to repair an
                      interior ceiling that experienced secondary damage solely due to a roof leak, provided that in each case
                      such leak resulted directly from the roof and is wholly unrelated to any casualty event, including roof leak
                      patching activities, except:
                      


                  </p>
                  <p class="smallfontpara">
                      <b class="boldfont">NOT COVERED:</b> cracked and/or missing tiles, shakes, shingles, sheet metal panels or solar roof panels
                      |foam roofs, tar and gravel, structural components |any other material not specifically mentioned as
                      covered |any defects related to labor or materials used in structural components, leaks, gutters,
                      downspouts, flashing, sheathing, framing, truss, patio covers, skylights, decks, solar equipment, vents,
                      heating or cooling equipment, antennae, satellite components, balconies, or chimneys, built-up roofs,
                      garage roofs | extraordinary painting | any type of damage and/or secondary damage not included above
                      in What Is Covered | damage caused by persons walking or standing on roof | damage due to lack of
                      caulking or other normal or preventative maintenance. 



                  </p>

                  <p class="smallfontpara">
                    <b class="boldfont">
                        NOTE:
                    </b>
                    Coverage under this Section is limited to Limited Roof Leak Repair Services only and does not
under any circumstances include coverage for a partial or complete replacement of a roof.

                </p>

                <p class="smallfontpara">
                    <b class="boldfont">
                        MAXIMUM COVERAGE:
                    </b>
                    $1,000 per Term.
                </p>

                <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                <h5> PREMIUM APPLIANCES COVERAGE: </h5>
                    <p class="smallfontpara">
                        Increases the maximum coverage limit for Refrigerators, Ovens, and Dishwashers identified in Section VI to double the standard coverage limit.
                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts listed for each covered appliance on section VI.


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> Any excluded components listed for each covered item, please refer to a specific covered appliance to see specific details.
                        
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        Refrigerators $4,000 per Term, Ovens $3,000 per Term, and Dishwashers $2,000 per Term.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>

                    <h5> PREMIUM SYSTEMS COVERAGE:</h5>
                    <p class="smallfontpara">
                        Increases the maximum coverage limit for Air Conditioning and Heating Systems to $5,000 each.  
                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts listed for Air Conditioning and Heating Systems in section VII. 


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> Any excluded components listed for Air Conditioning and Heating Systems, please refer to each covered system to see specific details.
                        
                        
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        Increases the maximum coverage limit for Air Conditioning and Heating Systems to $5,000 each.
                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> GUEST HOUSE </h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> Extending the coverage to a guest house of up to 800 square feet, covering the
                        appliances and systems that are covered with the plan. except:



                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> Any excluded components listed for each covered item, please refer to a specific
                        covered item to see specific details.
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        See each item coverage limit for more details. EHW will cover up to $5,000 on all covered items combined per term.

                    </p>

                    <div data-pdfmake="{&quot;left&quot;:120, &quot;width&quot;:300, &quot;color&quot;:&quot;red&quot;, &quot;margin&quot;:[5,5,5,5], &quot;thickness&quot;:2}"></div>
                    <h5> SELLER’S COVERAGE </h5>
                    <p class="smallfontpara">
                        <b class="boldfont">WHAT IS COVERED:</b> All components and parts needed to perform the full functionality of covered
                        appliances and systems; limited to Covered Items, components, and parts for the following major systems
                        - Air Conditioning, Heating, Electrical, Plumbing (excluding coverage for Plumbing stoppages), Water
                        Heater, Refrigerator and Oven. Coverage is limited to repairs and parts required for the Breakdown of a
                        covered item which can be repaired, except:


                    </p>
                    <p class="smallfontpara">
                        <b class="boldfont">NOT COVERED:</b> Coverage does not apply to the Breakdown of a covered item which cannot be repaired;
                        the total amount which EHW will pay if one or more of these Covered Items experiences a Breakdown
                        during this period is limited to fifteen hundred dollars ($1,500), in the aggregate, for expenses to access,
                        diagnose or repair all of these Covered Items (with each claim being subject to all additional limitations
                        under this Agreement, including but not limited to Sections XI. D.-G.).
                    </p>

                    <p class="smallfontpara">
                        <b class="boldfont">
                            MAXIMUM COVERAGE:
                        </b>
                        $1,500 per Term.

                    </p>

                    <h4>IX. OTHER COVERAGE; ADDITIONAL FEES</h4>

                    <p class="smallfontpara">
                      <b>A.</b> You are obligated to pay the difference between:
                    </p>

                    <ul class="smallfontpara">
                      <li>
                          1. the Other Coverage benefit which EHW pays under this Section IX., in accordance
      with all limitations set forth in this Section and elsewhere in this Agreement, and

                      </li>
                      <li>
                          2. the total amount of fees charged by a governmental entity or Repair Technician in
      connection with the repair or replacement of such covered items.
                      </li>
                  
                  </ul>
                  <p class="smallfontpara">
                    <b>B.</b> The Service Provider may require you to pay an additional fee to dispose
of the Covered Item or one of its components and/or parts.
                </p>

                <h4>
                  X. GENERAL AND PARTIAL EXCLUSIONS
                </h4>
                <p class="smallfontpara">
                  <b>A .</b> General Exclusions. The following exclusions are General Exclusions from coverage. 
                  This Agreement does not provide any coverage or other benefit for: 
                </p>

                <ul class="smallfontpara">
                  <li>
                      1. Routine maintenance (you are obligated to routinely perform and pay for
  maintenance and cleaning of covered items as specified by the manufacturer);


                  </li>
                  <li>
                      2. Flues, venting, chimneys, and exhaust lines;

                  </li>
                  <li>
                      3. Replacement, repair or remediation of a Covered Item that experiences Cosmetic
  Damage;
                  </li>
                  <li>
                      4. Electronic, computerized, or home management systems;
                  </li>
                  <li>
                      5. Radon monitoring systems, fire sprinkler systems, and solar systems and
  components;
                  </li>
                  <li>
                      6. Loss of income; utility bills; living expenses;
                  </li>
                  <li>
                      7. Food spoilage;
                  </li>
                  <li>
                      8. Repair, replacement, installation, or modification of any component or part of a
  covered item that has been or is determined to be defective by a state or federal
  agency, or for which a manufacturer has issued, or issues, a warning, recall, or
  determination of defect;
                  </li>
                  <li>
                      9. Repair or replacement required in connection with an event or occurrence covered
  under a homeowner's policy, renter's insurance policy, umbrella policy or other
  insurance policy, irrespective of which person(s) or entity is the named insured or an
  additional insured;

                  </li>
                  <li>
                      10. Repair or replacement required as a result of accidents; fire, freeze, flood, or other
  acts of God; neglect; misuse; abuse; missing parts; vandalism; or damages due to pests
  or pets.

                  </li>
                  <li>
                      11. Repair or replacement required as a result of structural defects; manufacturer
  defects; power failure, shortage, surge or overload; inadequate capacity; cosmetic
  defects; or design flaws.

                  </li>
                  <li>
                      12. Repair or replacement required as a result of consequential or secondary damage,
  including but not limited to any damage resulting from water, gas, smoke, fire, oil, or
  other natural or man made substances or materials.
                  </li>
                  <li>
                      13. Repair or replacement required as a result of any damages due to a Repair
  Technician's conventional repair efforts of the primary item.
                  </li>
                  <li>
                      14. Except as otherwise provided in Section VIII (if you selected the optional Limited
  Roof Leak Repair coverage), any repair or replacement in respect to any aspect of the
  exterior of the residence, including but not limited to its roof, roof shingles, roof tiles,
  sheet metal roofing, roof surface, flashing, gutters, windows, skylights, doors, sliding
  glass or screen door, foundation, basement, crawl space, concrete, concrete block, 
  balcony, porch, patio, deck, awning, mounted exterior installations, sunshade, chimney, 
  fireplace, firepit, sidewalks, driveway, mailbox, brick, stone, stucco, masonry or siding. 
                  </li>
                  <li>
                      15. Closing or providing access to any covered items.

                  </li>
                  <li>
                      16. Cost of carpentry, construction, or other modifications made necessary by a covered
  repair or replacement;


                  </li>
                  <li>
                      17. Except as otherwise provided in Section IX.E., any system or appliance upgrades,
  or repairs or replacements required:


                      <ul>
                          <li>
                              a. when the breakdown is due to missing components, parts, or
  equipment;
                          </li>
                          <li>
                              b. when the breakdown is due to lack of capacity in the existing system or
  appliance;

                          </li>
                          <li>
                              c. when the breakdown is due to under or oversized systems in relation to
  the square footage of the area being heated or cooled; or
                          </li>
                          <li>
                              d. to comply with any federal, state, or local laws, regulations or
                              ordinances, utility regulations, or building or zoning code requirements.
                          

                          </li>
                      </ul>

                  </li>
                  <li>
                      18. Performing service, or paying remediation costs, that relate in any manner to hazardous or toxic materials, mold, mildew, bio-organic growth, red-tagged units, gas leaks, carbon monoxide leaks, and any other hazardous contaminants, rot, fungus, or pest damage, or for:
                      <ul>
                          <li>
                              a. Damages from such causes;
                          </li>
                          <li>
                              b. Diagnosis, removal or remediation of such conditions; or
                          </li>
                          <li>
                              c. Repairs or replacements necessitated by such causes.

                          </li>
                      </ul>
                  </li>

                  <li>
                      19. Repair or replacement required as a result of any damages or malfunctions due to
  undetectable and detectable pre-existing conditions which are defects or mechanical
  failures that could or could not have been detected by a visual inspection or simple
  mechanical test.

                  
                  </li>
                  <li>
                      20. Repair or replacement required as a result of any damages or malfunctions due to
  mismatched systems where the indoor and outdoor units were not properly matched to
  each other in capacity or efficiency for proper operation.

                  
                  </li>
                  <li>
                      21. Repair or replacement required as a result of any damages or
malfunctions arising from any parts and/or components not provided
within What Is Covered throughout sections VI, VII, and VIII.

                  </li>
                  <li>
                      22. Except as otherwise provided in Sections VI, VII and VIII, repair or
replacement required as a result of any damages or malfunctions arising
from any parts and/or components not related to the full mechanical and/
or electrical functionality of a covered item including cosmetic parts and
components, racks, shelves, glass, lighting, doors, doors seal, hinges,
trays, gaskets, baskets, rollers, switches, sensors, controllers, chains,
gears, springs, latches, tracks, knobs, dials, tubes, touch panels, rollers,
keypad, alarms, timers, filters, blankets, rotisseries, venting, freon,
maintenance, noise, panels, tanks, expansion tanks, assembly
components, cabinetry, effectiveness of performance, support
equipment, Insulation, flues, solar and/or geothermal components,
cosmetic damage, leaks of any kind and or similar parts and components.
                  </li>
                  <li>
                      23. Repair or replacement required as a result of any damages or malfunctions due to
                      Improper installations, repairs, or modifications of any covered item.
                  
                  </li>
                  <li>
                      24. Repair or replacement required as a result of any damages or malfunctions due to
                      rust, corrosion, or sediment.
                  
                  </li>
                  <li>
                          25. Except as otherwise provided in Sections VI, VII and VIII, Replacement, repair or remediation of a Covered Item that experiences any kind of leaks.
                      
                  </li>
                  <li>
                      26. Repair or replacement required as a result of any damages or
malfunctions arising from circuit overload, loss and/or damage arising out
of power failure, power surge, flood and/or fire.
                  </li>
                 
              </ul>

              <p class="smallfontpara">
                <b>B.</b> Partial Exclusions. The following are Partial Exclusions from coverage or are
Excluded Fees. Except as otherwise specified in this Agreement, EHW is not
responsible or liable for:
            </p>
            <ul class="smallfontpara">
                <li>
                    1. Providing or closing access to covered items;

                </li>
                <li>
                    2. Costs of construction, carpentry, or other modifications necessary to remove,
relocate, or install equipment; or

                </li>
                <li>
                    3. Restoration of any wall or floor coverings, cabinets, counter tops, tiling, paint, or the
like.

                </li>
            </ul>

            <h4>
              XI. LIMITATIONS ON LIABILITY
            </h4>

            <p class="smallfontpara">
              <b>A.</b> For the First 90 Days of the Term. Subject to the other limitations under this Section XI and the Agreement, the following additional limitations on our liability apply to every Breakdown that is otherwise covered under this Agreement, for the First 90 Days of the Term:
              
          </p>
          <ul class="smallfontpara">
              <li>
                  1.  EHW provides no replacement coverage regarding the Breakdown of a covered item which cannot be repaired;
              </li>
              <li>
                  2. EHW provides coverage for repairs and parts required for the Breakdown of a covered item which can be repaired; and
              </li>
              <li>
                  3. EHW's Total Liability for the First 90 Days of the Term for repairs and parts required is limited to paying You in the aggregate up to $300; and
              </li>
              <li>
                  4. The above limitations apply only to the first term of a new agreement, not renewals.
              </li>
          </ul>
         
          <p class="smallfontpara">
              B. For Repair or replacement required as a result of any damages or malfunctions arising from lack of maintenance and/or lack of service required on any type of cooling and/or heating systems and components not limited to yearly checkup routine and cleaning services, EHW's Total Liability for repairs and parts, or a replacement, is limited to paying You in the aggregate up to $500.00 per term.
          </p>
  
          <p class="smallfontpara">
              <b>C.</b> For Water Heater Repair or replacement required as a result of any damages or malfunctions arising from leaks of any kind and/or lack of service required on any type of water heater systems and components not limited to yearly checkup routine and cleaning services, EHW's Total Liability for repairs and parts, or a replacement, is limited to paying You in the aggregate up to $500.00 per term.
  
              
          </p>
  
          <p class="smallfontpara">
              <b>D.</b> For the Term. Subject to the other limitations under this Section XI and the
                  Agreement, the following additional limitations on our liability apply to every Breakdown
                  that is otherwise covered under this Agreement for the Term:
  
              
          </p>
          <ul class="smallfontpara">
              <li>
                  1. Standard Total Liability. EHW's standard Total Liability Per Term for all Breakdowns
                  and fees and reimbursements under this Agreement is limited to paying in the
                  aggregate a total of fifteen thousand dollars ($15,000), including sales tax, for the
                  Breakdown of all Covered Items that occur during the Term. If the Declaration of
                  Coverage indicates your Purchase Price included payment for a higher limit as to Our
                  Total Liability, then Our Total Liability under this Section XI.B.1. shall be the figure
                  shown on the Declaration of Coverage.
  
              </li>
              <li>
                  2. Our Total Liability Per Category. EHW's standard Total Liability Per Category Per
                  Term for all Breakdowns and fees and reimbursements under this Agreement is limited
                  to paying in the aggregate the Maximum Category Coverage specified for that Category,
                  including sales tax, for the Breakdown of all Covered Items in that Category that occur
                  during the Term. If the Declaration of Coverage indicates your Purchase Price included
                  payment for a higher limit as to Our Total Liability Per Category, then Our Total Liability
                  under this Section XI.B.2. shall be the figure shown on the Declaration of Coverage,
                  subject to Section XI.B.3.
  
              </li>
              <li>
                  3. Our Total Liability Per Covered Item Per Category. EHW's standard Total Liability Per
                  Covered Item Per Category Per Term for all Breakdowns and fees and reimbursements
                  Per Covered Item under this Agreement is limited to paying in the aggregate the
                  Maximum Coverage for such Covered Item, and such coverage for each type of
                  Covered Item in a Category is limited solely to the first of that type of Covered Item to
                  experience a Breakdown during the Term. If the Declaration of Coverage indicates your
                  Purchase Price included payment for: (a) a higher limit as to Our Total Liability Per
                  Covered Item Per Category, then Our Total Liability under this Section XI.B.3. shall be
                  the figure shown on the Declaration of Coverage; and (b) coverage of more than one (1)
                  unit of the type of Covered Item within a Category, then Our Total Liability under this
                  Section XI.B.3. may include coverage for the Breakdown of a second unit of that type of
                  Covered Item in that Category as indicated on the Declaration of Coverage, subject to
                  the limitations of Section XI.B.3.(a).
  
              </li>
          </ul>
          <p class="smallfontpara">
              <b>E.</b> For a Covered Item - 10 years old and older. Subject to the other
              limitations under this Section XI and the Agreement, the following additional
              limitations on our liability apply to every Breakdown if the Covered Item is at
              least 10 years old as of the date of the Breakdown:
  
  
              
          </p>
          <ul class="smallfontpara">
              <li>
                  1. EHW shall have no obligation to replace a Covered Item if the total cost to
  replace such would exceed the depreciation value of the Covered Item, in
  which case EHW shall pay to You up to the depreciation value for an item
  older than 10 years toward the replacement costs.
  
              </li>
  
              <li>
                  2. EHW’s Total Liability regarding the Covered Item and any replacement
  costs relating thereto during the Term shall be limited to EHW’s payment to
  You of $750 toward the replacement costs under Section XI.D.1.
  
              </li>
          </ul>
          <p class="smallfontpara">
              <b>F.</b> For a Covered Item – Not Repairable; Parts Unavailable. Subject to the
              other limitations under this Section XI and the Agreement, the following
              additional limitations on our liability apply to every Breakdown if the Covered
              Item requires parts essential to its operation which are no longer available
              from established parts suppliers, or if the Covered Item otherwise cannot be
              repaired:
  
          
          </p>
          <ul class="smallfontpara">
              <li>
                  1. if the Covered Item cannot be repaired, EHW may pay You up to the
  depreciation value of the Covered Item toward the replacement costs in lieu
  of replacing the Covered Item, or (b) the total cost to replace a Covered Item
  with a comparable replacement item is less than the depreciation value, EHW
  may replace the Covered Item or may pay You the purchase price of the
  replacement item in lieu of replacing the Covered Item; and
              </li>
              <li>
                  2. EHW's total liability regarding the Covered Item and any replacement costs
  relating thereto during the Term shall be limited to EHW's payment to You
  under Section XI.E.1(a) or (b), or to the purchase price which EHW paid to
  purchase a comparable replacement of the Covered Item under Section
  XI.B.1.(b).
  
              </li>
          </ul>
          <p class="smallfontpara">
              <b>G.</b> Your Financial Obligations. You at all times are responsible for paying: (1) all Service
                  Fees, (2) all Special COPAYMENT FEES, and (3) the difference between: (i) any amount which
                  EHW pays regarding a Covered Item under this Agreement, in accordance with the
                  limitations set forth in this Section XI and elsewhere in this Agreement, and (ii) the total
                  amount charged by a governmental entity or Repair Technician in connection with the
                  repair or replacement of such Covered Item.
  
              
          </p>
          <p class="smallfontpara">
              <b>H.</b> We have the right to request purchase and/or maintenance records, repair or
              installation records, certifications, and home inspection reports, among other
              pieces of evidence, for any reason and at any time, including but not limited
              to reviewing any claims, or reviewing Our decision to deny any claims. If you
              do not provide us with any of the above requested evidence, we reserve the
              right to limit or deny your repair, replacement and/or cash in lieu of repair or
              replacement.
              
              
          </p>
          <p class="smallfontpara">
              <b>I.</b> We have the sole right to determine whether a Covered Item will be
  repaired or replaced. We reserve the right to offer cash or cash equivalent in
  lieu of repair or replacement in the amount of our actual cost (which at times
  may be less than retail) to repair or replace any Covered Item. Cash or cash
  equivalent offered in lieu of repair or replacement are limited to the
  depreciation value of the Covered Item and does not include the costs of
  shipping, tax, or installation. In the event a covered system or appliance is
  deemed irreparable or it is not cost effective to repair, we may replace the
  system or appliance with a system or appliance of like capacity, in the price
  of which shall not exceed the depreciated value of the system or appliance
  being replaced. The cash settlement shall be in an amount not to exceed the
  depreciated value of the component, system, or appliance being replaced.
  When cash or cash equivalent is issued to replace a Covered Item, unless the
  appliance or system is replaced, you may not make subsequent claims on
  such Covered Item for 12 months from the date of the issue.
          </p>
          
          <p class="smallfontpara">
              <b>J.</b> We are not liable for any failure to obtain timely service or delays in obtaining parts or equipment or for delays due to conditions beyond Our control, including, but not limited to, labor difficulties, strikes, riots, pandemic, war, acts of war, fire, floods, embargoes, insurrections, or acts of god. We will continue to perform this Agreement with reasonable scheduling whenever such events causing delays are eliminated.
              
          </p>
          <p class="smallfontpara">
              <b>K.</b> You agree that We are not liable for the negligence or other conduct of the Service Provider, nor are We an insurer of Service Provider’s performance. You also agree that we will not be liable for damages caused by the service provider, including but not limited to indirect, incidental, consequential or punitive damages. YOU EXPRESSLY WAIVE ALL RIGHTS TO SUCH DAMAGES.
              
          </p>
          <p class="smallfontpara">
              <b>L.</b> You hereby waive all rights to claim attorneys’ fees, consequential, punitive, indirect, incidental, and/or multiplied or otherwise increased damages, and any other damages, other than for the actual out-of-pocket expenses.
              
          </p>

          <h4>
            XII. MULTI-USER SYSTEMS AND APPLIANCES
          </h4>

          <p class="smallfontpara">
            <b>A.</b> If this Agreement is for a duplex, triplex, or fourplex dwelling, then all units within the
dwelling must be covered by one EHW Agreement for coverage to apply to shared
systems and appliances.

        </p>
        <p class="smallfontpara">
            <b>B.</b> If this Agreement is for a multi-unit dwelling other than those specified in Section
XII.A., then only items contained within the confines of each individual unit are covered.
Shared systems and appliances are not covered.

        </p>
        <p class="smallfontpara">
            <b>C.</b> Except as otherwise provided in this Section XII, shared systems and appliances are
            not covered.
        

        </p>

        <h4>
          XIII. COVERAGE BENEFITS
        </h4>

        <p class="smallfontpara">
          <b>A.</b> We have a simplified claims process.

      </p>
      <p class="smallfontpara">
          <b>B.</b> We seek to handle claims quickly and efficiently.
      </p>
     
      <p class="smallfontpara">
          <b>C.</b> There are no limits on the number of claims that you can request service for annually.

      </p>
      <p class="smallfontpara">
          <b>D.</b> There may be potential options, following diagnosis, for you to choose to receive
repair or replacement services or cash payment for the total approved cost of the repair
or replacement minus diagnosis fees. See Section III.

      </p>

      <h4>XIV. RENEWAL TRANSFER</h4>

      <p class="smallfontpara">
        <b>A.</b> Renewal. EHW may renew this Agreement at its sole discretion. Such agreements will automatically renew on a monthly basis, and you will automatically be charged the standard monthly subscription fee on a monthly basis. In the event we elect to renew your Agreement, you will be notified of the terms within 60 days prior to expiration of your Agreement. No contract or cancellation fees apply in the case of cancelling the renewed agreement. Please see Supplemental State Specific Provisions for additional details that may supplement or amend these provisions.

    </p>

    <p class="smallfontpara">
        <b>B.</b> Transfer. (i) If this Agreement has not expired or been canceled, and we have not
        paid under this Agreement an aggregate amount equal to Our Total Liability - Per Term
        under Section XI.A.2. for coverage in the Term, then this Agreement is transferable for
        the remainder of its Term to a person who purchases, leases or subleases the
        Residence located at the street address designated above (“Transferee”). If ownership
        of the Residence changes during the Term, you must (a) contact us at (888) 354-8383
        within fifteen (15) days after the date when the Transferee purchased the Residence,
        and (b) pay the applicable transfer fee to effect the transfer of coverage to the 
        Transferee.(ii) If you submitted a Valid Home Inspection Report to us prior to the 
        Effective Date, we will waive your obligation to pay a transfer fee if the Transfer occurs 
        within 60 days of the Agreement Effective Date. (iii) If a home inspection is completed 
        during the transfer of the Residence, defects of Covered items found at the time of the 
        home inspection are excluded from coverage hereunder until proof of repair or 
        replacement and payment of all related charges is provided to and received by us. (iv) 
        Please see Supplemental State Specific Provisions, for additional details which may 
        supplement or amend these provisions. 
    </p>

    <h4>
      XV. CANCELLATION
    </h4>

    <p class="smallfontpara">
      <b>A.</b> You or We may cancel this Agreement. Please see Supplemental State Specific
Provisions, for additional details which supplement or amend these provisions.

  </p>
    <p class="smallfontpara">
        <b>B.</b> Additionally, Agreement Holder shall be obligated to pay an administrative
        cancellation fee equal to $50.00 to cancel the Agreement after the Agreement Effective
        Date. Please see Supplemental State Specific Provisions, for additional details which
        supplement or amend these provisions.
    </p>
    <p class="smallfontpara">
        <b>C.</b> If the Term of this Agreement exceeds one year, no administrative cancellation fee
will be applied if You or We cancel this Agreement at any time.

    </p>

    <h4>
      XVI. MISCELLANEOUS
    </h4>

    <p class="smallfontpara">
      <b>A.</b> Full Faith And Credit. The obligations of EHW under the Agreement are backed by
      the full faith and credit of EHW.
  
  </p>
  <p class="smallfontpara">
      <b>B.</b> Purchase Not Required For A Loan. You are not obligated to purchase this
Agreement in order to be eligible for a loan from a financial institution.

  </p>
  <p class="smallfontpara">
      <b>C.</b> Dispute Remedy. Any claim, dispute or controversy, regarding any Agreement, tort,
      statute, or otherwise (“Claim”), arising out of or relating to this Agreement or the
      relationships among the parties hereto shall be resolved by one of the following means:
      Either party may seek binding arbitration by one arbitrator administered by the American
      Arbitration Association (“AAA”), under the AAA Consumer Rules in effect at the time the
      Claim is filed (“AAA Rules”). Copies of the AAA Rules and forms can be located at
      www.adr.org, or by calling 1-800-778-7879. The arbitrator's decision shall be final,
      binding, and non-appealable. Judgment upon the award may be entered and enforced
      in any court having jurisdiction. This clause is made pursuant to a transaction involving
      interstate commerce and shall be governed by the Federal Arbitration Act.Neither party 
      shall sue the other party other than as provided herein or for enforcement of this clause 
      or of the arbitrator's award; any such suit may be brought only in Federal District Court 
      for the District or, if any such court lacks jurisdiction, in any state court that has 
      jurisdiction. The arbitrator, and not any federal, state, or local court, shall have exclusive 
      authority to resolve any dispute relating to the interpretation, applicability, 
      unconscionability, arbitrability, enforceability or formation of this Agreement including 
      any claim that all or any part of the Agreement is void or voidable. However, the 
      preceding sentence shall not apply to the clause entitled “Class Action Waiver.” 
  </p>
  <p class="smallfontpara">
      <b>D.</b> If you have more than one agreement with us, you must submit 1 arbitration for each agreement. You hereby waive any right to initiate 1 arbitration covering multiple agreements.
  
  </p>
  <p class="smallfontpara">
      <b>E.</b> Class Action Waiver. Any Claim must be brought in the parties' individual capacity,
      and not as a plaintiff or class member in any purported class, collective, representative,
      multiple plaintiff, or similar proceeding (“Class Action”). The parties expressly waive any
      ability to maintain any Class Action in any forum. The arbitrator shall not have authority
      to combine or aggregate similar claims or conduct any Class Action nor make an award
      to any person or entity not a party to the arbitration. Any claim that all or part of this
      Class Action Waiver is unenforceable, unconscionable, void, or voidable may be
      determined only by a court of competent jurisdiction and not by an arbitrator. THE
      PARTIES UNDERSTAND THAT THEY WOULD HAVE HAD A RIGHT TO LITIGATE
      THROUGH A COURT, TO HAVE A JUDGE OR JURY DECIDE THEIR CASE AND TO
      BE PARTY TO A CLASS OR REPRESENTATIVE ACTION, HOWEVER, THEY
      UNDERSTAND AND CHOOSE TO HAVE ANY CLAIMS DECIDED INDIVIDUALLY,
      THROUGH ARBITRATION.
  
  </p>

  <p class="smallfontpara">
      <b>F.</b> Additional Details. Please see Supplemental State Specific Provisions, for additional
      details which supplement or amend these provisions.

  </p>
  <h4>SUPPLEMENTAL STATE SPECIFIC PROVISIONS</h4>
  <p class="smallfontpara">
    These Supplemental State Specific Provisions are incorporated by reference into and 
    are made a part of this Agreement.
 </p>


 <h4>WYOMING</h4>

                               <div>
                                <p class="smallfontpara">
                                  Section XIII.B.is amended to provide as follows:
                                </p>
                                <p class="smallfontpara">
                                  A.If you are the original purchaser and you return this Agreement to us:
                                </p>
                                <p class="smallfontpara">
                                  1. within 30 days of the date it was mailed to you or within 30 days of delivery if it was delivered to you at the
time of sale, or within 30 days of the Agreement Purchase Date, whichever date is later, then (i) the Agreement is
void, and (ii) we will refund the full Purchase Price less the value of all service(s) you received within 30 days
after the date you returned this Agreement to us.
                                </p>
                                <p class="smallfontpara">
                                  2.more than 30 days after the Agreement Purchase Date,then you will receive a pro rata refund of the Agreement
Fee (Purchase Price) consideration for the unexpired term of the Agreement, based on the number of elapsed
months, less the value of all service(s) you received and less the administrative cancellation fee of fifty dollars
($50).
                                </p>
                                <p class="smallfontpara">
                                  B. If we terminate this Agreement, we will mail you written notice stating the reason and the effective date of
cancellation to your last known address according to our records at least ten (10) days prior to cancellation by us.
We will not provide prior notice if we cancel for your nonpayment, material misrepresentation by you to us, or a
substantial breach of duties by you relating to the covered product or its use
                                </p>
                                <p class="smallfontpara">
                                  C.A ten percent (10%) penalty per month shall be added to any refund that is not paid or credited within 30 days
after You return this Agreement to Us.

                                </p>
                                </div>

            </div>

        </div>

       
    </div>

    <div #footerData class="footerCSS">
        <img src="footerImage" alt="#" />
    </div>


